import React from "react";

import ButtonSection from "../../components/ButtonSection/ButtonSection";
import ReadAloud from "../../components/ReadAloud/ReadAloud";

const ProofOfConcept = ({ fontSize }) => {
  const sections = {
    Results: (
      <div>
        <ReadAloud>
          <h2
            style={{
              fontSize: `${30 + fontSize}px`,
              color: "var(--logo)",
              marginBottom: "2vh",
            }}
          >
            Results
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            To develop our proof of concept, our original vision was to
            construct 4 strains of yeast with quantified production of alpha
            pinene, beta caryophyllene, THC and CBD, respectively. Due to
            significant delays in our lab progress caused by procurement issues,
            we were limited to successful cloning of all genes necessary for
            alpha pinene, THC and CBD into yeast, as well as successful cloning
            of beta caryophyllene genes into <i>E. coli</i>.
          </div>
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/results-fig-1.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 1: Agarose gel following amplification of gene inserts with
              re-designed primers. Lanes from top to bottom are pCARY plasmid
              backbone, <i>Aa</i>QHS1+pGAL1/10, pGAL1/10+<i>Sc</i>ERG20, tTEF1,
              <i>Cs</i>OAC+pGAL1/10, pCBGA plasmid backbone, 1kb ladder.
          </figcaption>
          <br />
          </div>
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/results-fig-2.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 2: Agarose gel following amplification of gene inserts with
              re-designed primers. Lanes from top to bottom are
              pGAL1/10+<i>Sl</i>NPPS+tTEF1, <i>Pt</i>PinS+pGAL1/10, pPINE backbone,
              <i>Cs</i>TKS+pGAL1/10, pGAL1/10+<i>Cs</i>AAE1, pGAL7+<i>Cs</i>THCAS,
              <i>Cs</i>THCAS+tTPS1, 1kb ladder.
          </figcaption>
          <br />
          </div>
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/results-fig-3.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 3: Agarose gel following amplification of gene inserts with
              re-designed primers. Lanes from top to bottom are mini-prepped
              XI-3 backbone, pGAL1/10+<i>Cs</i>PT4+tTEF1, XI-3 backbone, re-run
              <i>Pt</i>PinS+pGAL1/10, mini-prepped XII-4 backbone, pGAL7+<i>Cs</i>CBDAS,
              <i>Cs</i>CBDAS+tTPS1, 1kb ladder.
          </figcaption></div>
          <br />
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/results-fig-4.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 4: Plated <i>E. coli</i> transformed with the pCBGA assembly mix
              and incubated at 37 degrees for 16 hours.
          </figcaption></div>
          <br />
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/results-fig-5.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 5: Agarose gel following miniprep on liquid culture
              resulting from inoculation by several different isolated colonies
              of pCBGA transformant. The faint bands above 10 kbp indicate
              successful transformation. For the cleanest results, the liquid
              cultures corresponding to the second, fourth and fifth bands from
              the top were used for subsequent steps.
          </figcaption></div>
          <br />
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
              marginTop: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/results-fig-6.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 6: Agarose gel following attempted troubleshooting of the
              amplification of the XI-3 plasmid backbone. Lanes from top to
              bottom are PHusion polymerase and high-GC buffer, blank, Q5 2x
              master mix with 5% DMSO, PHusion polymerase and hot start buffer,
              Q5 2x master mix. The results indicate that PHusion polymerase
              combined with a high-GC buffer was successful at amplifying the
              desired fragment.
          </figcaption></div>
        </ReadAloud>
        <ReadAloud>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            In order to demonstrate a full proof of concept, we describe in
            separate subsections the quantification step we would have employed
            next, as well as a transport system design that we have developed in
            order to increase the rate of transport of the cannabinoid
            precursors out of the cell.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Overall, we believe that we have established a framework for all
            fundamental work required to transform the conventional batch
            process of cannabinoid and terpene production towards a more
            economic continuous production, including creating the basic yeast
            strains for protein expression, theoretical designs of processes of
            quantification, as well as theoretical work in terms of potential
            improvements to our system through our metabolic engineering
            modelling, bioreactor analysis, and transport system design. The
            production of cannabinoids and terpenes is already a growing
            industry within the Canadian synthetic biology community, and so
            rather than focusing on identifying a completely novel system, we
            want to use the international stage of iGEM as a platform to
            de-stigmatize the concept of cannabis as a drug that warrants
            further research.
          </div>
        </ReadAloud>
      </div>
    ),
    "Production quantification": (
      <div>
        <ReadAloud>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            The procedures outlined here are extracted from literature and
            describe what we would have employed as our next step for
            identifying and quantifying our products.
          </div>
        </ReadAloud>
        <br />
        <ReadAloud>
          
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Terpene Quantification and Extraction (procedure extracted from
            Ignea et al., 2019)
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Grow transformed <i>S. cerevisiae</i> strains overnight at 30 &deg;C
            and 150 rpm and subsequently induce in 2-mL liquid media using 20-mL
            glass vials with magnetic screw cap. Extract the terpenes using 1%
            (w/v) Diaion HP20 as adsorbent resin, which has been activated in
            100% methanol. Following culturing, collect the beads and wash with
            H<sub>2</sub>O to remove the yeast cells, then elute the beads three
            times with ethanol, followed by three pentane elutions with
            20–30 min incubation between each step. Extract the pentane phase
            with equal volume of water, then concentrate to a 100-microlitre
            final volume and analyze with GC-FID analysis.
          </div>
        </ReadAloud>
          <br />
        <ReadAloud>
          
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Cannabinoid Quantification and Extraction (procedure extracted from
            Luo et al., 2019)
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Grown transformed <i>S. cerevisiae</i> strains overnight in yeast
            extract peptone dextrose (YPD) medium and then back-dilute to OD600
            nm = 0.2 into yeast extract peptone galactose (YPG). Supplement
            medium with 1 mM olivetolic acid, and incubate strains for 48 h in
            24-deep-well plates (800 r.p.m.) at 30 &deg;C while supplementing
            with 2% (w/v) galactose every 24 h. Subsequently, treat samples with
            2 U/OD zymolyase (2 h, 30 &deg;C, 800 r.p.m.), followed by ethyl
            acetate/formic acid (0.05% (v/v)) extraction in a 2:1 ratio and
            bead-beating (30 s<sup>-1</sup>, 3 min). Separate organic and
            inorganic layers by centrifugation at 12,000<i>g</i> for 1 min, and
            extract samples three times, then evaporate the combined organic
            layers in a vacuum oven (50 &deg;C). Resuspend the remainders
            acetonitrile/H<sub>2</sub>O/formic acid (80%/20%/0.05% (v/v/v)), and
            then filter with Ultrafree-MC columns (0.22 μm pore size,
            polyvinylidene difluoride (PVDF) membrane. Analyze products using
            high-performance liquid chromatography with UV detection (HPLC–UV,
            Agilent 1200 series), with the mobile phase composing of 0.05% (v/v)
            formic acid in water (solvent A) and 0.05% (v/v) formic acid in
            acetonitrile (solvent B). Separate cannabinoids via gradient
            elution, and detect with diode array detection at 270 nm.
          </div>
        </ReadAloud>
          <br />
        <ReadAloud>
          
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            References
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Ignea, C., Raadam, M. H., Motawia, M. S., Makris, A. M., Vickers, C.
            E., & Kampranis, S. C. (2019). Orthogonal monoterpenoid biosynthesis
            in yeast constructed on an isomeric substrate.{" "}
            <i>Nature Communications</i>, <i>10</i>(1).
            <a href="https://doi.org/10.1038/s41467-019-11290-x">https://doi.org/10.1038/s41467-019-11290-x</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Luo, X., Reiter, M. A., d’Espaux, L., Wong, J., Denby, C. M.,
            Lechner, A., Zhang, Y., Grzybowski, A. T., Harth, S., Lin, W., Lee,
            H., Yu, C., Shin, J., Deng, K., Benites, V. T., Wang, G., Baidoo, E.
            E., Chen, Y., Dev, I., … Keasling, J. D. (2019). Complete
            biosynthesis of cannabinoids and their unnatural analogues in yeast.{" "}
            <i>Nature, 567</i>(7746), 123–126.
            <a href="https://doi.org/10.1038/s41586-019-0978-9">https://doi.org/10.1038/s41586-019-0978-9</a>
          </div>
          <br />
        </ReadAloud>
      </div>
    ),
    "Transport system": (
      <div>
        <ReadAloud>
          <h2
            style={{
              fontSize: `${30 + fontSize}px`,
              color: "var(--logo)",
              marginBottom: "2vh",
            }}
          >
            Transport System
          </h2>
          <h2
            style={{
              fontSize: `${30 + fontSize}px`,
              color: "var(--logo)",
              marginBottom: "2vh",
            }}
          >
            Motivation
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Previously we have targeted the challenge of developing yeast
            strains capable of producing the cannabinoids CBD and THC, and the
            terpenes alpha pinene and beta caryophyllene with the aim to offer a
            more sustainable and efficient way to produce these compounds than
            the traditional cultivation method. The engineering of yeast to be
            able to produce CBD and THC offers an alternative to traditional
            production of cannabinoids; however, it comes with its own
            challenges. In terms of overall yield, the biggest limitation to
            overcome is the lack of systemic secretion of cannabinoids from the
            cell. First of all, the products are toxic to the cell, so allowing
            them to build up would impose an upper bound on the amount of
            product each cell may produce before apoptosis may occur. Secondly,
            with the lack of suitable transportation systems, purification of
            the products is reliant on the lysis of cells. This lysis step not
            only requires that the cell seed be replaced in the production line,
            but also disturbs the production process, and is overall a step back
            from the sustainability initiative. Terpenes are in general fairly
            capable of diffusing across the cell membrane into the external
            environment, especially into an organic phase (Vermaas et al.,
            2018). By adding a secretion system and allowing a continuous
            culture flow, the production of cannabinoids in yeast may be greatly
            benefited.
          </div>
        </ReadAloud>
        <br />
        <ReadAloud>
          <h2
            style={{
              fontSize: `${30 + fontSize}px`,
              color: "var(--logo)",
              marginBottom: "2vh",
            }}
          >
            Purpose
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            In this section we introduce a theoretical design of developing a
            secretion system for THC and CBD in yeast using ABC yeast
            transporters as the basic structure and proposing structural
            engineering to recognize our molecules of interest and transport
            them outside the cell.
          </div>
        </ReadAloud>
        <br />
        <ReadAloud>
          <h2
            style={{
              fontSize: `${30 + fontSize}px`,
              color: "var(--logo)",
              marginBottom: "2vh",
            }}
          >
            Introduction
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            ATP-binding cassette proteins (ABC) are one of the largest protein
            families with a consistent structure and organization but with a
            wide range of functions and that interact with many different
            molecules (Jungwirth & Kuchler, 2006). In yeast, there are at least
            30 genes encoding for ABC proteins from where several proteins work
            in membrane translocation and that are related to cellular
            detoxification (Jungwirth & Kuchler, 2006). This capacity of ABC
            translocator proteins provide resistance to the build-up of certain
            compounds and is referred to as ABC drug efflux pumps, and shows
            similarity to the approaches that microorganisms and cancer cells
            take to deal with foreign compounds (Jungwirth & Kuchler, 2006).
            Generally, ABC proteins are characterized by a conserved ATP binding
            motif, signature motifs, and at least one nucleotide-binding domain
            which is the one carrying the motifs. The nucleotide-binding domain
            is required for fueling the membrane transport (Jungwirth & Kuchler,
            2006). Interestingly the specificity in substrate of ABC
            membrane-bound transporters is defined by transmembrane-spanning
            segments (Jungwirth & Kuchler, 2006). Today, due to the ABC
            transporters’ diversity and variability, all the roles and all the
            possible substrates are not known.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            These characteristics make ABC transporters a great candidate for
            seeking potential membrane transporters for THC and CBD and thus
            motivate one of the two alternatives that we will consider in this
            section.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Currently, there is no ABC transporter known to translocate THC or
            CBD. However, the diversity that ABC transporters show due to their
            variations of transmembrane-spanning segments, as well as the little
            that is known about their substrates allow us to consider them as
            candidates for potential cannabinoid membrane transporters.
          </div>
        </ReadAloud>
        <br />
        <ReadAloud>
          <h2
            style={{
              fontSize: `${30 + fontSize}px`,
              color: "var(--logo)",
              marginBottom: "2vh",
            }}
          >
            Proposed Design
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            To use the evolutionary diversity of ABC transporter to our
            advantage, we aim to apply a metagenomic approach by making use of a
            metagenomic library such as a corn soil sample library (11AW) (Cheng
            & Charles, 2016). We would use a mix of a bioinformatic and
            functional metagenomic screen where we want to screen for cosmids in
            the library containing ABC transporters’ hallmarks such as the
            presence of at least one nucleotide-binding domain (NBD) carrying a
            highly conserved ATP-binding motif, as well as signature motifs
            (Jungwirth & Kuchler, 2006). After confirmation of the hallmark, the
            cosmids will be going through a functional metagenomic screening
            where transformation of chosen cosmids will be executed in yeast and
            an assay will be done to screen for THC and CBD secretion (Cheng &
            Charles, 2016). It is important to consider that since we may be
            using a foreign ABC transporter that is not part of the wild-type
            repertoire of yeast, we may have to also consider the genes that are
            involved in the regulation. If a useful ABC transporter is
            identified by the metagenomic approach, the regulation of this
            possible novel protein should be addressed. If the metagenomic
            approach is insufficient, then we may develop a useful transporter
            using a transporter of similar molecules as a base, and we modify
            its sequence either by random mutation or site-specific mutagenesis.
            In either case, we must consider the original transporter regulation
            system as well. As an example, the ABC transporter regulation
            pathways in yeast are shown in Figure 1.
          </div>
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/transport-fig-1.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 1: PDR network in yeast. Genetic pathways involved in
              regulation of the ABC family in yeast (Figure extracted from
              Chicca et al., 2018)
          </figcaption></div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Considering the possibility that the bioinformatic/functional
            metagenomic screen might not provide a successful identification of
            a cannabinoid ABC transporter, we can choose to do a follow-up
            approach where we use a transporter enzyme that has been
            characterised to transport molecules with similarities to THC or
            CBD, such as (-)-cis-PET, which is an analog of THC (Figure 2) and
            has been greatly underconsidered. It shows fairly high activity on
            CB1 receptors found in <i>Radula perrottetii</i> (liverwort), and low
            levels of activity with membrane transporters such as dopamine and
            serotonin transporters (Figure 3) (Chicca et al., 2018).{" "}
          </div>
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/transport-fig-2.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 2: Shows a comparison of (-)-delta nine-trans-THC and
              (-)-cis-PET structure and their plant sources (Figure extracted
              from Chicca et al., 2018)
          </figcaption></div>
          <br />
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/transport-fig-3.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 3: 6 Effects of (-)-delta nine-trans-THC and (-)-cis-PET on
              44 CNS targets (GPCRs, ion channels, nuclear receptors, membrane
              transporters, and enzymes). (Figure extracted from Chicca et al.,
              2018)
          </figcaption></div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Another similar molecule to consider is anandamide, which is a lipid
            mediator capable of binding to CB1 receptors and acting as an
            endogenous ligand (Scherma et al., 2019). There is evidence of
            variation in its concentration by passive diffusion and
            substrate-affinity transporter activity (Moore et al., 2005).
            Moreover, anandamide studies have shown reduction of anandamide
            concentration upon exposure to analogues that are hypothesised to
            inhibit anandamide transporters (Figure 4) (Moore et al., 2005).
          </div>
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/transport-fig-4.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 4: Enzyme-inhibitor activity assays demonstrating the
              competitive nature of LY2318912 vs. AM404 for inhibition of
              anandamide uptake. (Figure extracted from Moore et al., 2005).
          </figcaption></div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            We may then take anandamide as a candidate and use a random approach
            like chimeragenesis methods (genetic mutations to present phenotypic
            variation) or an engineering approach with site specific mutagenesis
            to identify amino acid sequences that are involved in the substrate
            recognition, which we may then seek to replace to improve
            recognition of THC or CBD as the substrate (Page Durland &
            Ahmadian-Moghadam, 2021).
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For chimeragenesis, there are several possible methods such as
            Random Chimeragenesis of Transient Templates (RACHITT) or DNA
            shuffling, which is used for molecular mutagenesis at a high
            recombination rate. The workflow for RACHITT is shown in Figure 5,
            where no thermocycling, strand switching, or staggered extension is
            used, but instead, the same effect is achieved through trimming, gap
            filling, and ligation of parental gene fragments hybridized on a
            transient DNA template. Another possible method is a
            random-and-extensive mutagenesis (REM), where many mutations are
            produced but there is no real control of the mutations (Page Durland
            & Ahmadian-Moghadam, 2021)
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For a more engineering-focused approach, we could use site-directed
            mutagenesis where the DNA is modified at a specific nucleotide
            location, causing a predetermined amino acid change (Edelheit,
            Hanukoglu, & Hanukoglu, 2009; Page Durland & Ahmadian-Moghadam,
            2021). Also, the popular CRISPR/Cas 9 approach can also possibly be
            employed here to produce a highly specific mutation (Cong & Zhang,
            2014).
          </div>
          <div style={{display: "flex", alignItems: "center", flexDirection: "column"}}>
          <img
            style={{
              maxWidth: "100%",
              border: "1px solid black",
              borderRadius: "20px",
              marginBottom: "20px",
            }}
            alt="alt"
            src="https://static.igem.wiki/teams/4393/wiki/proof-of-concept/transport-fig-5.jpg"
          />
          <figcaption style={{fontSize: `${16 + fontSize}px`, textAlign: "center"}}>
              Figure 5: Diagram for the workflow of Random chimeragenesis on
              transient templates (RACHITT). (Figure extracted from Coco et al.,
              2001)
          </figcaption></div>
          <br />
        </ReadAloud>
        <br />
        <ReadAloud>
          <h2
            style={{
              fontSize: `${30 + fontSize}px`,
              color: "var(--logo)",
              marginBottom: "2vh",
              marginTop: "3vh",
            }}
          >
            References
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Balabanova, L., Golotin, V., Podvolotskaya, A., & Rasskazov, V.
            (2015). Genetically modified proteins: Functional improvement and
            chimeragenesis. <i>Bioengineered</i>, <i>6</i>(5), 262-274.
            <a href="https://doi.org/10.1080%2F21655979.2015.1075674">https://doi.org/10.1080%2F21655979.2015.1075674</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Chicca, A., Schafroth, M. A., Reynoso-Moreno, I., Erni, R.,
            Petrucci, V., Carreira, E. M., & Gertsch, J. (2018). Uncovering the
            psychoactivity of a cannabinoid from liverworts associated with a
            legal high. <i>Science Advances</i>, <i>4</i>(10), eaat2166.
            <a href="https://doi.org/10.1126/sciadv.aat2166">https://doi.org/10.1126/sciadv.aat2166</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Coco, W. M., Levinson, W. E., Crist, M. J., Hektor, H. J., Darzins,
            A., Pienkos, P. T., Squires, C. H., & Monticello, D. J. (2001). DNA
            shuffling method for generating highly recombined genes and evolved
            enzymes. <i>Nature Biotechnology</i>, <i>19</i>(4), 354-359.
            <a href="https://doi.org/10.1038/86744">https://doi.org/10.1038/86744</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Cong, L., Zhang, F. (2015). Genome Engineering Using CRISPR-Cas9
            System. In S. Pruett-Miller (Eds.), <i>Chromosomal Mutagenesis</i>.
            Methods in Molecular Biology (Vol. 1239). Humana Press, New York,
            NY. <a href="https://doi.org/10.1007/978-1-4939-1862-1_10">https://doi.org/10.1007/978-1-4939-1862-1_10</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Durland, J., & Ahmadian-Moghadam, H. (2021). Genetics, Mutagenesis.
            In <i>StatPearls</i>. StatPearls Publishing.
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Edelheit, O., Hanukoglu, A., & Hanukoglu, I. (2009). Simple and
            efficient site-directed mutagenesis using two single-primer
            reactions in parallel to generate mutants for protein
            structure-function studies. <i>BMC Biotechnology</i>, <i>9</i>, 61.
            <a href="https://doi.org/10.1186/1472-6750-9-61">https://doi.org/10.1186/1472-6750-9-61</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Ignea, C., Raadam, M. H., Motawia, M. S., Makris, A. M., Vickers, C.
            E., & Kampranis, S. C. (2019). Orthogonal monoterpenoid biosynthesis
            in yeast constructed on an isomeric substrate. <i>Nature
            Communications</i>, <i>10</i>, 3799.
            <a href="https://doi.org/10.1038/s41467-019-11290-x">https://doi.org/10.1038/s41467-019-11290-x</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Jungwirth, H., & Kuchler, K. (2006). Yeast ABC transporters – A tale
            of sex, stress, drugs and aging. <i>FEBS Letters</i>, <i>580</i>(4),
            1131-1138. <a href="https://doi.org/10.1016/j.febslet.2005.12.050">https://doi.org/10.1016/j.febslet.2005.12.050</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Luo, X., Reiter, M. A., d’Espaux, L., Wong, J., Denby, C. M.,
            Lechner, A., Zhang, Y., Grzybowski, A. T., Harth, S., Lin, W., Lee,
            H., Yu, C., Shin, J., Deng, K., Benites, V. T., Wang, G., Baidoo, E.
            E., Chen, Y., Dev, I., … Keasling, J. D. (2019). Complete
            biosynthesis of cannabinoids and their unnatural analogues in yeast.
            <i>Nature</i>, <i>567</i>(7746), 123–126.
            <a href="https://doi.org/10.1038/s41586-019-0978-9">https://doi.org/10.1038/s41586-019-0978-9</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Moore, S. A., Nomikos, G. G., Dickason-Chesterfield, A. K., Schober,
            D. A., Schaus, J. M., Ying, B. P., Xu, Y. C., Phebus, L., Simmons,
            R. M. A., Li, D., Iyengar, S., & Felder, C. C. (2005).
            Identification of a high-affinity binding site involved in the
            transport of endocannabinoids. <i>Proceedings of the National Academy
            of Sciences of the United States of America</i>, <i>102</i>(49),
            17852-17857. <a href="https://doi.org/10.1073/pnas.0507470102">https://doi.org/10.1073/pnas.0507470102</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Scherma, M., Masia, P., Satta, V., Fratta, W., Fadda, P., & Tanda,
            G. (2019). Brain activity of anandamide: A rewarding bliss? <i>Acta
            Pharmacologica Sinica</i>, <i>40</i>(3), 309-323.
            <a href="https://doi.org/10.1038/s41401-018-0075-x">https://doi.org/10.1038/s41401-018-0075-x</a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Vermaas, J. V., Bentley, G. J., Beckham, G. T., & Crowley, M. F.
            (2018). Membrane permeability of terpenoids explored with molecular
            simulation. <i>The Journal of Physical Chemistry B</i>, <i>122</i>(45),
            10349–10361. <a href="https://doi.org/10.1021/acs.jpcb.8b08688">https://doi.org/10.1021/acs.jpcb.8b08688</a>
          </div>
        </ReadAloud>
      </div>
    ),

    Methods: (
      <div>
        <ReadAloud>
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Organisms and Strains:
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>
                <i>E. coli</i> strain DH5alpha, of genotype{" "}
                <i>
                  Δ(argF-lac)169, φ80dlacZ58(M15), ΔphoA8, glnX44(AS), deoR481,
                  rfbC1, gyrA96(NalR), recA1, endA1, thiE1
                </i>{" "}
                and <i>hsdR17</i>, was used for cloning (Song et al., 2015).
              </li>
              <li>
                <i>S. cerevisiae</i> strain BY4741, of genotype{" "}
                <i>MATa his3Δ1 leu2Δ0 met15Δ0 ura3Δ0</i>, was used as the
                chassis for cannabinoid/terpene production (Brachmann et al.,
                1998).
              </li>
            </ul>
          </div>
        </ReadAloud>

        <br />
        <ReadAloud>
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Plasmids:
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>
                From the EasyClone-MarkerFree Vector Set, which was a gift from
                Irina Borodina (Addgene Kit #1000000098) (Jessop-Fabre et al.,
                2016):
                <ul>
                  <li>
                    pCfB2312: EasyClone-MarkerFree vector for expression of Cas9
                    from <i>Streptococcus pyogenes</i>. pCfB2312
                    (TEF1p-Cas9-CYC1t_kanMX) was a gift from Irina Borodina
                    (Addgene plasmid #78231;{" "}
                    <a href="http://n2t.net/addgene:78231">
                      http://n2t.net/addgene:78231
                    </a>
                    ; RRID: Addgene_78231) (Jessop-Fabre et al., 2016).
                  </li>
                  <li>
                    {" "}
                    pCfB3040: EasyClone-MarkerFree backbone vector for
                    integration into <i>S. cerevisiae</i> locus XII-4.
                    Transformed <i>E. coli</i> cells are resistant to
                    ampicillin, while transformed <i>S. cerevisiae</i> are
                    resistant to G418/geneticin. pCfB3040(XII-4 MarkerFree) was
                    a gift from Irina Borodina (Addgene plasmid #73280;{" "}
                    <a href="http://n2t.net/addgene:73280">
                      http://n2t.net/addgene:73280
                    </a>
                    ; RRID: Addgene_73280) (Jessop-Fabre et al., 2016).
                  </li>
                  <li>
                    pCfB3049: EasyClone-MarkerFree vector for expression of
                    guide RNA targeting the <i>S. cerevisiae</i> integration
                    locus XII-4. pCfB3049(gRNA XII-4) was a gift from Irina
                    Borodina (Addgene plasmid #73291;
                    http://n2t.net/addgene:73291; RRID: Addgene_73291)
                    (Jessop-Fabre et al., 2016).
                  </li>
                  <li>
                    pCfB2904: EasyClone-MarkerFree backbone vector for
                    integration into <i>S. cerevisiae</i> locus XI-3.
                    Transformed <i>E. coli</i> cells are resistant to
                    ampicillin, while transformed <i>S. cerevisiae</i> are
                    resistant to G418/geneticin. pCfB2904(XI-3 MarkerFree) was a
                    gift from Irina Borodina (Addgene plasmid #73276;
                    http://n2t.net/addgene:73276; RRID: Addgene_73276)
                    (Jessop-Fabre et al., 2016).
                  </li>
                  <li>
                    pCfB3045: EasyClone-MarkerFree vector for the expression of
                    guide RNA targeting the <i>S. cerevisiae</i> integration
                    locus XI-3. pCfB3045(gRNA XI-3) was a gift from Irina
                    Borodina (Addgene plasmid #73287;{" "}
                    <a href="http://n2t.net/addgene:73287">
                      http://n2t.net/addgene:73287
                    </a>
                    ; RRID: Addgene_73287) (Jessop-Fabre et al., 2016).
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </ReadAloud>

        <ReadAloud>
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            gBlocks:
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For pPINE plasmid:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Pt</i>PinS+pGAL1/10:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            TCACAGCGTAACAGGATCGATAACCGTACGTTTTACAAGACTCTTAGTCTCTATATTGGCCACAGAGTAACCGTCTCTGTATTTGTATCCGCAATGGAATGCTCTACTGATGTCGAAGGCATGCTTCTTAGCAGATATTGGTACGCTGGAGTTGGGCTTCAACAATTCCCAGTTAAGACCCTTAATCACATCGCTAATCATGGCATTTAGGTGATTCAGTGCGTCCTCTTCTGTCGTTCCAGGGTTATCCTTCATGTAACAAGAGATACATGATGCTTCCTCCCCTCTCGCACGGTCAGCTTGATAACACCTAGTGTCTCCCCTCAATCTAAGGATAGCACTGGCAAGATCGTTTAACTGTGAAGGAATATCCACCTCTTTTAATACGTGTTCTGGAAATGGAATGTCAGTGGTTAGGATTGGCTGTAGAGCGCTAACTCTATGCCCGGAGCTCACCTTCCCATTTTCATAATATTCCTCGAAGGTTGGTACTTCGCCAGATGCGATCCATTTAGCCTCTTGCATATAGGCATCGATATATTCCTCCCAGGCTTGTCTGCAATAATTCAGTGTATCACGTCCTTGGGCTTTATCGGCCTCTTGACTCATTTCATTAACAGTGTTATATACAATCATGTAAACACCCTTCATATACTCGGGTAAACATTCTGTCGCTGAAGGGTCCCAACGCTTGATAGCGGAAGTGAATAACTCCAGCTCGTCCAGCGTGCCAAAAGTGTCATACATATCGTCCAACACGGTAATTATATGGCATGCTTTAGCGAAGCCTAATCTAAACCCTGAATGTTGGGGCTCAAATGCAATACAGCTTGCCAAAGTATAATACTCTACATGTCTATGACGGCAAAACGTCATCTGTGGTGAACCTGACCCCTTCCACCAACGTACCAAGTACTCCAATTCCCTCTTCTGTAAGGCATGAAATATGTTGAATTCCAGTTTAGCCAACTCTAGTAACTTTTCTGTCTTCATGTAGGACTTTGAATTCTCGGTGTCCTGCCCAAAAACGTCAATATAATTTCTTGCCTCCAAACGGGGTAAATAGGTATGCCACCCATATTCCAAAACGTCCCCAATCTCACGTGAAAAAGAGCTCACCGGAATTTTCTGTAATGCTTCTTTCAGATACTTGGCTGAGAAAGACTCGGCCTCATCCATGACCTTTTCGCCCGGAAAGGCTATTAGTGACGCTCTGTACAAGTTTAGGACAGTTCTTATTTGATCCTCTGTCTGCTTCAAGGTACATGCGAATTGTCCACTCTGGTTCTTGAAGTGATTCAATACGTCCGCACTTACATCATATCCATGTAATCTCAATGTCCTCAAACCCAGTGCGGTACTGTTTAAATCAGTGACCACTGACTCACGGCCGCAACCAATACCCTTCTCGCTCCAATACCTGTAAACATGGTCAAGGGCAGACTTTATCTCTTTTTTGAAGTGTCTGTCAATCCCAAGTCTCTCAACGGAGTCCACCATCCATAGCCTCTGTATCAAGTCGTCTAAGGGCGTTATGCTTTCCCCATCCTCGTTGGACATGCTATTGAATGAATTCTTGACTTCACCAATCAGTCTTTCGGCACGTTCTCTATAAGACGGCTCCCCGTACGGGCTTGATAAAGATTGAATTAAATCGTCATCCCAAAGGTTACTGTGGAAGTCGCCCCTTCTCCTGATCACTGCATCATCTGAAACCGCTGTCCTTAAGTTCATGCTCATTGATGCGGACATTGTGTTGGATCCCGAATTTTCAAAAATTCTTACTTTTTTTTTGGATGGACGCAAAGAAGTTTAATAATCATATTACATGTGTGAAATTGTTATCCGCTCACAATTCCACACAACATATCTAATCTTACTTATATGTTGTGGAAATGTAAAGAGCCCCATTATCTTAGCCTAAAAAAACCTTCTCTTTGGAACTTTCAGTAATACGCTTAACTGCT
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL1/10+<i>Sl</i>NPPS+tTEF1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            CATTGCTATATTGAAGACGGATTAGAAGCCGCCGAGCGGGTGACAGCCCTCCGAAGGAAGACTCTCCTCCGTGCGTCCTCGTCTTCACCGGTCGCGTTCCTGAAACGCAGATGTGCCTCGCGCCGCACTGCTCCGAACAATAAAGATTCTACAATACTAGCTTTTATGGTTATGAAGAGGAAAAATTGGCAGTAACCTGGCCCCACAAACCTTCAAATGAACGAATCAAATTAACAACCATAGGATGATAATGCGATTAGTTTTTTAGCCTTATTTCTGGGGTAATTAATCAGCGAAGCGATGATTTTTGATCTATTAACAGATATATAAATGCAAAAACTGTCCCTATCAGTGATAGAGATCTCCCTATCAGTGATAGAGATATTACTTCTTATTCAAATGTAATAAAAGTATCAACAAAAAATTGTTAATATACCTCTATACTTTAACGTCAAGGAGAAAAAACCCCGGTTCTTATTAAAGAATTCAACACAATGTCCTTAAACCTTCAAACTGAAAAGCTCTGTTACGAAGACAATGATAATGATCTCGATGAGGAGCTTATGCCTAAGCATATTGCTTTAATCATGGACGGCAACCGACGTTGGGCTAAAGATAAGGGATTGGAAGTTTACGAAGGCCATAAACATATTATTCCAAAATTGAAAGAAATCTGTGACATTTCCTCTAAGTTAGGTATCCAAATAATCACGGCATTTGCCTTCTCAACGGAGAACTGGAAGAGATCAAAAGAAGAAGTTGATTTCTTGCTACAAATGTTTGAGGAAATTTACGACGAGTTTTCCCGCTCTGGAGTCAGGGTGTCAATTATCGGTTGCAAAAGCGATTTGCCAATGACACTGCAAAAATGTATTGCATTAACTGAAGAAACCACAAAGGGTAATAAAGGGCTACACCTTGTTATTGCTTTGAACTATGGGGGTTATTATGATATATTACAGGCCACTAAATCGATAGTAAACAAAGCTATGAATGGTTTGTTAGATGTAGAAGACATTAACAAGAATCTGTTTGATCAGGAATTGGAAAGTAAATGCCCCAATCCTGATCTATTAATAAGAACAGGAGGTGAACAAAGGGTCAGTAATTTTTTATTGTGGCAGCTAGCGTATACAGAGTTCTACTTTACCAATACCCTTTTCCCGGACTTTGGTGAAGAAGATCTGAAGGAGGCAATAATGAATTTTCAACAAAGACACAGAAGATTCGGCGGACATACTTATTGACTAAGGTTACCAAGGCTGCTCAAAAGGCTGCTAAGAAATAAGGAGATTGATAAGACTTTTCTAGTTGCATATCTTTTATATTTAAATCTTATCTATTAGTTAATTTTTTGTAATTTATCCTTATATATAGTCTGGTTATTCTAAAATATCATTTCAGTATCTAAAAATTCCCCTCTTTTTTCAGTTATATCTTAACAGGCGACAGTCCAAATGTTGATTTATCCCAGTCCGATTCATCAGGGTTGTGAAGCATTTTGTCAATGGTCGAAATCACATCAGTAATAGTGCCTCTTACTTGCCTCATAGAATTTCTTTCTCTTAACGTCACCGTTTGGTCTTTTATAGTTTCGAAATCTATGGTGATACCAAATGGTGTTCCCAATTCATCGTTACGGGCGTATTTTTTACCAATTGAAGTATTGGAATCGTCAATTTTAAAGTATATCTCTCTTTTACGTAAAGCCTGCGAGATCCTC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For pCARY plasmid:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Aa</i>QHS1+pGAL1/10:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            TCAAATGGGTATTGGGTGTACAAGAAGTGACTTGATATGATCTTTCAACTCTTCGCCGACGTTAGTGAATCCGTCTTTGTGTTTGTATAAAACATCCATAACCTGTGCCAGATTAATCACTCTCATCATCAAGGGCATTGGAATGTCTTTACGGACTAATGATTCTCTGGTAATGTCCTTCCAGGCATCCTCAATCTTCTTATTGAAAACTTTCAAAACGTGTTCTTCAGTTACATCGTATTGTTTCATGTAACTTTCCACAGAGGAGGCCACATGTATTCTTTCTTTTTCCTCTTTTTGAGAATGGATGTCGTCCATTAATCTCGCTATTGCACAGCTAGCTTTGATAATAGGTGGTTTTGTCAATGCCCATTTGAAGGCTTCATCTGTGACAATGTCACCCATGCCCACAAAACACGTTGTAGCTAGCATGGAATAGCCTGAACTAACAAAAGCGACTGACATATGTTCTTCAGCAGTAGGAACATAACCCTCATTGGCCCATTTCGCTTCCATCATATATGATCGGATGAACTCTTTCATACTTTCCTTGGCGTAGGACAAGTGATGAGCCTTCCCTTCCTTACCCATTATTTCCTCCATTTCAATATATATATCTAGTACCCCTTGATATAACAACTTCAAATATTCAGGAAGCATATCGATACAAGTTATAGACCAACGCTGTATTGCTTCAGTAAAAATCTTTAATTCTTCATAAGTTCCGTAAGCATCGTAGGTGTCATCCAAGACTGTAGCTAAACTAATAACTTTAGCGAGGAATATTCTAGCTTGGCTGTACTTAGGCTCAAAATAAACTCCAAGTGCCCAAAAGTAGCACTCGACCATTCTATCTCGCGCGTAAGGCAGGTTGTTCGGAACATCAAGGCCCTTCCACCATCTCGAAACCTCAGATAATTCCTTCCGATGCAGTGATTGTAGCAGATTAAAACCTAGCTTTGCAAGTTTTAATAGCGATTCGTTATGGCTGGCTTGCTGCTCATACATCGGAATGTATCTCAACGCCTCGAGTCTTGTTAACCTCTTATGCAATGGTTGTTTTAATGCTTCTTGGATGTATGTACTGAGGGTGGGGTTCGTGTGTACTAGATCCTTTGCAATCTTTTCTAAGCAAGTTCTTGTGAAGACTAAGGCATCATCTAGCACTCCCTCACCTTGAACGCGCAAATAAGTGGCTTCATATAATTCTAATAATCCCTCTACGTCGTTCGTCAGGGATTCTTTAAACGAACCGTCTTCTTTTTTATAATTTTTAAAGATGTCACAAGATACATAGAAACCTTGCTGTCTCAATATCCTAAACCACAAGCTTGGAGACCTACCTTTCCAATCATCACCGTAGGTATCATAGATATGTTGTAGAGCTTGTTCTATCTCTTCTTCGAAATGATAAGCAATACCAAGTCTCTGAATTGCGTCAATCAATTTCAACAGATTGGTGTGTTCAGTCTGAACATCTAAAGAGGAGACCAAATCTTTCCTCACATCTTCACGCAATTCATTCACTACCTGTTCCACATTAGCTTGCTCTGCTTGCTTATCGTCAAAGATAAGAAATTGATCAGCCCATACAGATGGTGGAAAATGAACAATAGGCCTAATAACCTTTTCTTCTTTAACTGAGGACATTGTGTTCGAATTTTCAAAAATTCTTACTTTTTTTTTGGATGGACGCAAAGAAGTTTAATAATCATATTACATGTGTGAAATTGTTATCCGCTCACAATTCCACACAACATATCTAATCTTACTTATATGTTGTGGAAATGTAAAGAGCCCCATTATCTTAGCCTAAAAAAACCTTCTCTTTGGAACTTTCAGTAATACGCTTAACTGCTCATTGCTATATTGAAGTACGGATTAGAAGCCGCCGAGCGGGTGACAGCCCTCCGAAGGAAGACTCTCCTCCGTGCGTCCTCGTCTTCACCGGTCGCGTTCCTGAAACGC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL1/10+<i>Sc</i>ERG20+tTEF1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            AGATGTGCCTCGCGCCGCACTGCTCCGAACAATAAAGATTCTACAATACTAGCTTTTATGGTTATGAAGAGGAAAAATTGGCAGTAACCTGGCCCCACAAACCTTCAAATGAACGAATCAAATTAACAACCATAGGATGATAATGCGATTAGTTTTTTAGCCTTATTTCTGGGGTAATTAATCAGCGAAGCGATGATTTTTGATCTATTAACAGATATATAAATGCAAAAACTGTCCCTATCAGTGATAGAGATCTCCCTATCAGTGATAGAGATATTACTTCTTATTCAAATGTAATAAAAGTATCAACAAAAAATTGTTAATATACCTCTATACTTTAACGTCAAGGAGAAAAAACCCCGGATCCTATTAAAAACACAATGTCCGCTTCTGAAAAAGAAATTAGACGAGAAAGATTCTTGAACGTTTTTCCTAAGCTTGTAGAGGAATTAAATGCATCCCTATTGGCTTACGGTATGCCTAAAGAAGCCTGTGATTGGTATGCACATAGCTTGAATTACAATACACCCGGAGGTAAACTGAATCGCGGTCTGTCAGTAGTCGATACGTATGCCATTTTGTCGAATAAGACCGTTGAGCAATTAGGTCAAGAAGAATATGAAAAAGTAGCTATACTTGGTTGGTGTATCGAATTGTTGCAGGCTTATTTCCTTGTTGCAGACGATATGATGGACAAGTCTATAACAAGAAGAGGGCAACCATGTTGGTATAAAGTGCCGGAAGTGGGTGAAATTGCTATCAACGATGCGTTTATGTTGGAGGCAGCCATATATAAGCTGTTAAAATCACATTTTCGTAATGAAAAGTACTATATTGATATAACAGAACTTTTTCACGAGGTTACTTTCCAAACGGAATTAGGCCAATTAATGGACTTGATCACAGCCCCAGAGGATAAAGTAGACCTATCCAAATTCTCGTTAAAGAAACATAGTTTTATAGTCACTTTCAAGACTGCATACTATAGTTTTTACTTGCCAGTGGCTTTGGCTATGTACGTTGCGGGAATTACCGACGAAAAGGATCTAAAGCAGGCTAGGGATGTTTTAATCCCTCTCGGAGAATACTTTCAAATTCAAGATGATTATTTAGATTGCTTCGGGACTCCAGAACAAATTGGCAAGATTGGTACTGACATCCAGGATAACAAATGTTCATGGGTCATCAACAAAGCTTTAGAGCTTGCATCTGCCGAGCAGAGGAAGACATTGGATGAGAATTATGGCAAAAAAGATTCAGTTGCTGAAGCAAAATGCAAGAAAATTTTTAACGACCTAAAGATTGAACAACTGTATCACGAGTACGAAGAATCTATTGCGAAAGATCTAAAAGCCAAAATAAGCCAAGTGGATGAAAGTAGAGGATTTAAGGCAGACGTTTTAACCGCTTTCCTCAATAAAGTCTACAAGCGTTCCAAATGACTAAGGTTACCAAGGCTGCTCAAAAGGCTGCTAAGAAATAAGGAGATTGATAAGACTTTTCTAGTTGCATATCTTTTATATTTAAATCTTATCTATTAGTTAATTTTTTGTAATTTATCCTTATATATAGTCTGGTTATTCTAAAATATCATTTCAGTATCTAAAAATTCCCCTCTTTTTTCAGTTATATCTTAACAGGCGACAGTCCAAATGTTGATTTATCCCAGTCCGATTCATCAGGGTTGTGAAGCATTTTGTCAATGGTCGAAATCACATCAGTAATAGTGCCTCTTACTTGCCTCATAGAATTTCTTTCTCTTAACGTCACCGTTTGGTCTTTTATAGTTTCGAAATCTATGGTGATACCAAATGGTGTTCCCAATTCATCGTTACGGGCGTATTTTTTACCAATTGAAGTATTGGAATCGTCAATTTTAAAGTATATCTCTCTTTTACGTAAAGCCTGCGAGATCCTC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For pCARY plasmid:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Aa</i>QHS1+pGAL1/10:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            TCAAATGGGTATTGGGTGTACAAGAAGTGACTTGATATGATCTTTCAACTCTTCGCCGACGTTAGTGAATCCGTCTTTGTGTTTGTATAAAACATCCATAACCTGTGCCAGATTAATCACTCTCATCATCAAGGGCATTGGAATGTCTTTACGGACTAATGATTCTCTGGTAATGTCCTTCCAGGCATCCTCAATCTTCTTATTGAAAACTTTCAAAACGTGTTCTTCAGTTACATCGTATTGTTTCATGTAACTTTCCACAGAGGAGGCCACATGTATTCTTTCTTTTTCCTCTTTTTGAGAATGGATGTCGTCCATTAATCTCGCTATTGCACAGCTAGCTTTGATAATAGGTGGTTTTGTCAATGCCCATTTGAAGGCTTCATCTGTGACAATGTCACCCATGCCCACAAAACACGTTGTAGCTAGCATGGAATAGCCTGAACTAACAAAAGCGACTGACATATGTTCTTCAGCAGTAGGAACATAACCCTCATTGGCCCATTTCGCTTCCATCATATATGATCGGATGAACTCTTTCATACTTTCCTTGGCGTAGGACAAGTGATGAGCCTTCCCTTCCTTACCCATTATTTCCTCCATTTCAATATATATATCTAGTACCCCTTGATATAACAACTTCAAATATTCAGGAAGCATATCGATACAAGTTATAGACCAACGCTGTATTGCTTCAGTAAAAATCTTTAATTCTTCATAAGTTCCGTAAGCATCGTAGGTGTCATCCAAGACTGTAGCTAAACTAATAACTTTAGCGAGGAATATTCTAGCTTGGCTGTACTTAGGCTCAAAATAAACTCCAAGTGCCCAAAAGTAGCACTCGACCATTCTATCTCGCGCGTAAGGCAGGTTGTTCGGAACATCAAGGCCCTTCCACCATCTCGAAACCTCAGATAATTCCTTCCGATGCAGTGATTGTAGCAGATTAAAACCTAGCTTTGCAAGTTTTAATAGCGATTCGTTATGGCTGGCTTGCTGCTCATACATCGGAATGTATCTCAACGCCTCGAGTCTTGTTAACCTCTTATGCAATGGTTGTTTTAATGCTTCTTGGATGTATGTACTGAGGGTGGGGTTCGTGTGTACTAGATCCTTTGCAATCTTTTCTAAGCAAGTTCTTGTGAAGACTAAGGCATCATCTAGCACTCCCTCACCTTGAACGCGCAAATAAGTGGCTTCATATAATTCTAATAATCCCTCTACGTCGTTCGTCAGGGATTCTTTAAACGAACCGTCTTCTTTTTTATAATTTTTAAAGATGTCACAAGATACATAGAAACCTTGCTGTCTCAATATCCTAAACCACAAGCTTGGAGACCTACCTTTCCAATCATCACCGTAGGTATCATAGATATGTTGTAGAGCTTGTTCTATCTCTTCTTCGAAATGATAAGCAATACCAAGTCTCTGAATTGCGTCAATCAATTTCAACAGATTGGTGTGTTCAGTCTGAACATCTAAAGAGGAGACCAAATCTTTCCTCACATCTTCACGCAATTCATTCACTACCTGTTCCACATTAGCTTGCTCTGCTTGCTTATCGTCAAAGATAAGAAATTGATCAGCCCATACAGATGGTGGAAAATGAACAATAGGCCTAATAACCTTTTCTTCTTTAACTGAGGACATTGTGTTCGAATTTTCAAAAATTCTTACTTTTTTTTTGGATGGACGCAAAGAAGTTTAATAATCATATTACATGTGTGAAATTGTTATCCGCTCACAATTCCACACAACATATCTAATCTTACTTATATGTTGTGGAAATGTAAAGAGCCCCATTATCTTAGCCTAAAAAAACCTTCTCTTTGGAACTTTCAGTAATACGCTTAACTGCTCATTGCTATATTGAAGTACGGATTAGAAGCCGCCGAGCGGGTGACAGCCCTCCGAAGGAAGACTCTCCTCCGTGCGTCCTCGTCTTCACCGGTCGCGTTCCTGAAACGC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL1/10+<i>Sc</i>ERG20+tTEF1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            AGATGTGCCTCGCGCCGCACTGCTCCGAACAATAAAGATTCTACAATACTAGCTTTTATGGTTATGAAGAGGAAAAATTGGCAGTAACCTGGCCCCACAAACCTTCAAATGAACGAATCAAATTAACAACCATAGGATGATAATGCGATTAGTTTTTTAGCCTTATTTCTGGGGTAATTAATCAGCGAAGCGATGATTTTTGATCTATTAACAGATATATAAATGCAAAAACTGTCCCTATCAGTGATAGAGATCTCCCTATCAGTGATAGAGATATTACTTCTTATTCAAATGTAATAAAAGTATCAACAAAAAATTGTTAATATACCTCTATACTTTAACGTCAAGGAGAAAAAACCCCGGATCCTATTAAAAACACAATGTCCGCTTCTGAAAAAGAAATTAGACGAGAAAGATTCTTGAACGTTTTTCCTAAGCTTGTAGAGGAATTAAATGCATCCCTATTGGCTTACGGTATGCCTAAAGAAGCCTGTGATTGGTATGCACATAGCTTGAATTACAATACACCCGGAGGTAAACTGAATCGCGGTCTGTCAGTAGTCGATACGTATGCCATTTTGTCGAATAAGACCGTTGAGCAATTAGGTCAAGAAGAATATGAAAAAGTAGCTATACTTGGTTGGTGTATCGAATTGTTGCAGGCTTATTTCCTTGTTGCAGACGATATGATGGACAAGTCTATAACAAGAAGAGGGCAACCATGTTGGTATAAAGTGCCGGAAGTGGGTGAAATTGCTATCAACGATGCGTTTATGTTGGAGGCAGCCATATATAAGCTGTTAAAATCACATTTTCGTAATGAAAAGTACTATATTGATATAACAGAACTTTTTCACGAGGTTACTTTCCAAACGGAATTAGGCCAATTAATGGACTTGATCACAGCCCCAGAGGATAAAGTAGACCTATCCAAATTCTCGTTAAAGAAACATAGTTTTATAGTCACTTTCAAGACTGCATACTATAGTTTTTACTTGCCAGTGGCTTTGGCTATGTACGTTGCGGGAATTACCGACGAAAAGGATCTAAAGCAGGCTAGGGATGTTTTAATCCCTCTCGGAGAATACTTTCAAATTCAAGATGATTATTTAGATTGCTTCGGGACTCCAGAACAAATTGGCAAGATTGGTACTGACATCCAGGATAACAAATGTTCATGGGTCATCAACAAAGCTTTAGAGCTTGCATCTGCCGAGCAGAGGAAGACATTGGATGAGAATTATGGCAAAAAAGATTCAGTTGCTGAAGCAAAATGCAAGAAAATTTTTAACGACCTAAAGATTGAACAACTGTATCACGAGTACGAAGAATCTATTGCGAAAGATCTAAAAGCCAAAATAAGCCAAGTGGATGAAAGTAGAGGATTTAAGGCAGACGTTTTAACCGCTTTCCTCAATAAAGTCTACAAGCGTTCCAAATGACTAAGGTTACCAAGGCTGCTCAAAAGGCTGCTAAGAAATAAGGAGATTGATAAGACTTTTCTAGTTGCATATCTTTTATATTTAAATCTTATCTATTAGTTAATTTTTTGTAATTTATCCTTATATATAGTCTGGTTATTCTAAAATATCATTTCAGTATCTAAAAATTCCCCTCTTTTTTCAGTTATATCTTAACAGGCGACAGTCCAAATGTTGATTTATCCCAGTCCGATTCATCAGGGTTGTGAAGCATTTTGTCAATGGTCGAAATCACATCAGTAATAGTGCCTCTTACTTGCCTCATAGAATTTCTTTCTCTTAACGTCACCGTTTGGTCTTTTATAGTTTCGAAATCTATGGTGATACCAAATGGTGTTCCCAATTCATCGTTACGGGCGTATTTTTTACCAATTGAAGTATTGGAATCGTCAATTTTAAAGTATATCTCTCTTTTACGTAAAGCCTGCGAGATCCTC
          </div>

          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For pCBGA plasmid:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Cs</i>OAC+pGAL1/10:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            TCACTTTCTAGGGGTATAATCGAATATTAGCAGCTTTTCCCAGAATGACCTGTAGACATCTCCAAAACCGACATGAGCGGGATGAATAATATAATCTTGAATTGTTTCAACAGATTCGAATGTAACTTCAACTATGTGCGTATAACCTTCTTCTTTGTTTTTTTGGGTTACATCTTTGCCCCAGTACACGTCCTTCATTGCTGGGATAATATTTACAAGATTCACGTAAGTCTTAAAAAATTCCTCTTTCTGGGCCTCAGTGATCTCGTCTTTAAATTTCAAAACTATTAAATGCTTGACAGCGGACATTGTTTTGCTAGCCGAATTTTCAAAAATTCTTACTTTTTTTTTGGATGGACGCAAAGAAGTTTAATAATCATATTACATGTGTGAAATTGTTATCCGCTCACAATTCCACACAACATATCTAATCTTACTTATATGTTGTGGAAATGTAAAGAGCCCCATTATCTTAGCCTAAAAAAACCTTCTCTTTGGAACTTTCAGTAATACGCTTAACTGCTCATTGCTATATTGAAGTACGGATTAGAAGCCGCCGAGCGGGTGACAGCCCTCCGAAGGAAGACTCTCCTCCGTGCGTCCTCGTCTTCACCGGTCGCGTTCCTGAAACGCAGATGTGCCTCGCGCCGCACTGCTCCGAACAATAAAGATTCTACAATACTAGCTTTTATGGTTATGAAGAGGAAAAATTGGCAGTAACCTGGCCCCACAAACCTTCAAATGAACGAATCAAATTAACAACCATAGGATGATAATGCGATTAGTTTTTTAGCCTTATTTCTGGGGTAATTAATCAGCGAAGCGATGATTTTTGATCTATTAACAGATATATAAATGCAAAAACTGTCCCTATCAGTGATAGAGATCTCCCTATCAGTGATAGAGATATTACTTCTTATTCAAATGTAATAAAAGTATCAACAAAAAATTGTTAATATACCTCTATACTTTAACGTCAAGGAGAAAAAACCCCGGATCCTATTAAATGATCAAACACAATGTCCGGATTATCTCTAGTTTGTACTTTTTCGTTTCAAACCAACTATCATACAC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL1/10+<i>Cs</i>PT4+tTEF1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            TTCTAAACCCTCACAACAAAAATCCAAAAAACAGCCTGTTGTCATATCAACACCCCAAAACACCGATAATCAAATCGTCTTATGATAATTTTCCATCGAAATATTGCTTAACGAAAAATTTTCACTTACTGGGTCTCAATAGTCATAATCGTATTTCCTCTCAATCTAGGAGTATTAGAGCCGGTTCTGATCAAATTGAAGGCAGTCCACATCATGAGTCCGATAACTCTATTGCGACAAAGATATTGAATTTCGGCCACACATGCTGGAAATTACAACGACCTTACGTAGTTAAGGGCATGATCAGTATAGCATGTGGGCTGTTCGGAAGAGAACTTTTCAATAATAGACATTTGTTTTCATGGGGTTTGATGTGGAAGGCATTTTTTGCTTTGGTGCCAATCTTATCTTTTAATTTTTTCGCTGCCATTATGAACCAGATCTATGATGTGGACATAGATAGGATTAACAAGCCCGACTTACCTCTTGTTAGCGGTGAAATGAGCATTGAAACCGCTTGGATACTATCAATAATTGTTGCGCTGACTGGGTTAATTGTAACCATCAAACTAAAAAGCGCTCCGCTATTTGTTTTCATCTACATTTTCGGTATTTTTGCTGGTTTCGCATATTCTGTCCCACCTATTAGATGGAAACAATATCCATTCACCAACTTTTTAATTACAATTTCCTCACATGTCGGACTTGCTTTTACTTCATACTCCGCTACTACGAGCGCATTAGGTTTGCCTTTTGTTTGGCGCCCAGCCTTTTCCTTCATCATCGCTTTCATGACAGTCATGGGTATGACCATTGCCTTCGCTAAGGACATAAGTGATATTGAGGGAGATGCGAAGTATGGTGTATCAACTGTAGCAACTAAGTTGGGTGCAAGAAACATGACGTTCGTGGTCTCAGGCGTTTTGCTGCTCAATTACTTAGTCAGTATATCCATCGGAATAATATGGCCCCAGGTTTTTAAGTCTAATATTATGATCCTTTCACATGCTATATTGGCCTTTTGTCTAATCTTCCAAACTAGAGAATTGGCATTGGCAAATTATGCCTCGGCTCCTTCTCGTCAGTTTTTCGAGTTTATTTGGTTGTTATACTACGCAGAATACTTTGTGTATGTATTTATTTAACTAAGGTTACCAAGGCTGCTCAAAAGGCTGCTAAGAAATAAGGAGATTGATAAGACTTTTCTAGTTGCATATCTTTTATATTTAAATCTTATCTATTAGTTAATTTTTTGTAATTTATCCTTATATATAGTCTGGTTATTCTAAAATATCATTTCAGTATCTAAAAATTCCCCTCTTTTTTCAGTTATATCTTAACAGGCGACAGTCCAAATGTTGATTTATCCCAGTCCGATTCATCAGGGTTGTGAAGCATTTTGTCAATGGTCGAAATCACATCAGTAATAGTGCCTCTTACTTGCCTCATAGAATTTCTTTCTCTTAACGTCACCGTTTGGTCTTTTATAGTTTCGAAATCTATGGTGATACCAAATGGTGTTCCCAATTCATCGTTACGGGCGTATTTTTTACCAATTGAAGTATTGGAATCGTCAATTTTAAAGTATATCTCTCTTTTACGTAAAGCCTGCGAGATCCTC
          </div>

          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For pTHCA plasmid:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Cs</i>TKS+pGAL1/10:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            TCAGTATTTGATTGGAACCGATCTGACAACAACCCTTTCGACTGTTAAACCGGGACCGAAACCGAACAATACTCCCCATTCGAATCCATCACCGGTAGTCGATTTACCTTCTTCCAGGCTCCTCTTTCTTAGTTCGTCCATAACAAATAAAACAGTGCTAGAACTCATGTTACCATGCTCTGACAATACATGGCGAGAATCAACAAATTTATCACTCTTTAGGTGTAACTTCTCTTCCACCTTATCTAGTATAGCTTTACCACCTGGGTGAGTTATCCAAAAAATGGAGTTCCAATCAGAAATGCCAATTGGTGTGAATGCTTCTATTAAGCATTTTTCTATATTATTTGAAATTAACATAGGGACATCCTTGTGAAGGTCGAAAATTAGACCAGCCTCTCTTATATGTCCTCCGATCGTACCTTCGGAGTTCGGGAGAATAGTTTGACCAGTAGAAACCAACTCGAATATTGGCCGTTCCCCCACAGATTCGTCTGGTTCGGCGCCAACAATGACAGCAGCGGCCCCGTCGCCAAAAATCGCTTGGCCCACTAACAACTCCAAATCAGATTCCGACGGACCACGAAAAAGACAAGCCATAATATCACAACAGACGGCAAGTACTCGTGCACCCTTATTATTTTCAGCGATATCTTTTGCAATCCTTAATACGGTTCCACCGCCATAACATCCCAACTGGTACATCATAACTCTTTTCACACTAGGGGACAAACCGAGTAACTTTGCACAATGGTAATCTGCCCCAGGCATATCGGTCGTACTGGCTGAAGTAAATATCAAGTGCGTTATCTTGCTCTTTGGCTGGCCCCATTCTTTGATTGCCTTGGCGCATGCGTCCTTCCCCAATTTAGGCACCTCAACTACCAACATGTCTTGTCTAGCATCTAAGGTTTGCATCTCATGTTCAACCAGTCTAGGGTTTTGTTTTAAATGTTCCTCATTCAGAAAACAATTCCTTTTTCTAATCATGGATTTGTCGCAAATTTTTCTGAATTTTTCTTTTAGCTGTGTCATATGTTCTGATTTTGTTACACGAAAATAATAATCGGGAAATTCATCTTGCAAAAGGATATTCTCGGGGTTCGCTGTTCCGATAGCCAGGACTGACGCTGGACCTTCAGCTCTAAGATGATTGGACATTGTGTTGAATTCCGAATTTTCAAAAATTCTTACTTTTTTTTTGGATGGACGCAAAGAAGTTTAATAATCATATTACATGTGTGAAATTGTTATCCGCTCACAATTCCACACAACATATCTAATCTTACTTATATGTTGTGGAAATGTAAAGAGCCCCATTATCTTAGCCTAAAAAAACCTTCTCTTTGGAACTTTCAGTAATACGCTTAACTGCTCATTGCTATATTGAAGTACGGATTAGAAGCCGCCGAGCGGGTGACAGCCCTCCGAAGGAAGACTCTCCTCCGTGCGTCCTCGTCTTCACCGGTCGCGTTCCTGAAACGCAGATGTGCCTCGCGCCGCACTGCTCCGAACAATAAAGATTCTACAATACTAGCTTTTATGGTTATGAAGAGGAAAAATTGGCAGTAACCTGGCCCCACAAACCTTCAAATGAACGAATCAAATTAACAACCATAGGATGATAATGCGATTAGTTTTTTAGCCTTATTTCTGGGGTAATTAATCAGCGAAGCGATGATTTTTGATCTATTAACAGATATATAAATGCAAAAACTGTCCCTATCAGTGATAGAGATCTCCCTATCAGTGATAGAGATATTACTTCTTATTCAAATGTAATAAAAGTATCAACAAAAAATTGTTAATATACCTCTATACTTTAACGTC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL1/10+<i>Cs</i>AAE1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            AAGGAGAAAAAACCCCGGATCCTATTAAAGAATTCAACACAATGTCCGGAAAAAATTATAAATCCTTAGACTCTGTCGTTGCATCTGACTTCATAGCCTTGGGTATCACGTCCGAAGTGGCAGAGACTCTACACGGTCGTTTGGCTGAAATTGTGTGTAATTATGGCGCCGCAACACCTCAGACTTGGATAAATATTGCTAATCACATTTTATCACCAGATTTGCCATTTTCTTTACATCAAATGCTCTTTTATGGATGTTATAAGGATTTCGGGCCGGCACCTCCAGCTTGGATTCCTGATCCAGAGAAAGTAAAGTCTACGAACCTAGGAGCGTTACTTGAGAAAAGAGGAAAAGAGTTTCTCGGTGTTAAGTACAAGGACCCAATATCGTCGTTCAGTCATTTTCAAGAATTTAGTGTACGAAACCCCGAAGTTTACTGGCGGACAGTTTTAATGGATGAAATGAAGATTTCTTTTTCCAAAGACCCAGAATGCATCTTAAGAAGAGATGACATTAACAATCCTGGGGGGAGTGAGTGGCTGCCGGGCGGTTATCTAAATAGCGCCAAGAACTGCCTTAACGTGAACTCTAATAAAAAGTTAAATGATACCATGATAGTGTGGAGAGACGAAGGCAACGATGATCTTCCATTGAACAAATTGACATTGGACCAACTGAGGAAGCGAGTCTGGCTAGTAGGCTATGCTTTGGAAGAAATGGGGTTAGAAAAGGGCTGCGCGATCGCGATTGATATGCCCATGCATGTCGATGCTGTTGTAATATATTTAGCCATCGTATTGGCAGGTTATGTTGTGGTCTCAATCGCTGATTCATTCTCAGCACCCGAAATAAGCACCAGATTACGCCTTTCCAAGGCGAAAGCCATTTTCACTCAAGATCATATCATCAGAGGAAAAAAGAGAATACCATTATACAGCCGTGTTGTTGAAGCAAAATCTCCCATGGCAATCGTTATCCCTTGTTCAGGCTCTAACATTGGCGCAGAATTACGTGATGGAGACATTTCTTGGGACTACTTTCTTGAAAGGGCCAAGGAATTTAAAAATTGTGAATTTACCGCACGTGAGCAGCCAGTGGATGCATACACCAATATTCTATTTAGCTCCGGAACAACCGGTGAACCAAAAGCTATTCCCTGGACTCAGGCGACACCTTTAAAGGCTGCTGCCGACGGTTGGAGCCACCTTGACATTAGAAAAGGCGATGTAATAGTTTGGCCGACTAACTTGGGGTGGATGATGGGTCCTTGGTTAGTTTACGCAAGTCTTCTTAACGGAGCTAGTATCGCCCTATATAATGGGTCACCATTGGTTTCCGGCTTTGCTAAATTTGTGCAGGATGCTAAAGTTACTATGTTAGGTGTTGTCCCTAGTATTGTTAGATCATGGAAGTCGACTAATTGTGTGTCAGGATACGATTGGTCCACAATCCGCTGCTTTTCTTCGTCTGGAGAGGCTTCTAACGTTGATGAATATCTATGGCTGATGGGTAGAGCTAATTATAAACCAGTCATTGAAATGTGTGGTGGTACCGAAATAGGTGGAGCATTTAGTGCCGGCTCCTTCCTACAAGCTCAATCATTGAGCTCTTTCTCATCCCAGTGTATGGGTTGTACCCTATATATTTTGGACAAAAATGGTTACCCTATGCCGAAGAATAAGCCTGGAATCGGTGAACTGGCATTGGGTCCTGTAATGTTTGGTGCCAGTAAAACTCTGTTGAACGGTAACCATCATGATGTCTACTTTAAAGGTATGCCAACTCTGAATGGTGAAGTATTAAGAAGGCACGGTGACATTTTCGAACTTACATCGAATGGTTACTATCATGCTCATGGTAGGGCCGATGACACGATGAATATAGGTGGAATAAAAATTTCATCTATTGAGATTGAAAGAGTTTGCAACGAGGTTGATGATCGTGTCTTCGAGACTACTGCTATAGGCGTGCCTCCCTTAGGTGGGGGTCCAGAACAACTCGTGATTTTTTTTGTCTTGAAGGATAGCAATGATACAACGATAGATTTGAATCAATTGAGATTGAGTTTCAACCTCGGTCTGCAAAAAAAATTAAATCCATTGTTCAAAGTAACGAGGGTAGTCCCATTATCGTCACTACCGAGAACAGCTACAAATAAGATTATGAGGAGAGTTTTGAGGCAACAATTCTCTCACTTCGAGTGAG
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL1/10+<i>Cs</i>AAE1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            AAGGAGAAAAAACCCCGGATCCTATTAAAGAATTCAACACAATGTCCGGAAAAAATTATAAATCCTTAGACTCTGTCGTTGCATCTGACTTCATAGCCTTGGGTATCACGTCCGAAGTGGCAGAGACTCTACACGGTCGTTTGGCTGAAATTGTGTGTAATTATGGCGCCGCAACACCTCAGACTTGGATAAATATTGCTAATCACATTTTATCACCAGATTTGCCATTTTCTTTACATCAAATGCTCTTTTATGGATGTTATAAGGATTTCGGGCCGGCACCTCCAGCTTGGATTCCTGATCCAGAGAAAGTAAAGTCTACGAACCTAGGAGCGTTACTTGAGAAAAGAGGAAAAGAGTTTCTCGGTGTTAAGTACAAGGACCCAATATCGTCGTTCAGTCATTTTCAAGAATTTAGTGTACGAAACCCCGAAGTTTACTGGCGGACAGTTTTAATGGATGAAATGAAGATTTCTTTTTCCAAAGACCCAGAATGCATCTTAAGAAGAGATGACATTAACAATCCTGGGGGGAGTGAGTGGCTGCCGGGCGGTTATCTAAATAGCGCCAAGAACTGCCTTAACGTGAACTCTAATAAAAAGTTAAATGATACCATGATAGTGTGGAGAGACGAAGGCAACGATGATCTTCCATTGAACAAATTGACATTGGACCAACTGAGGAAGCGAGTCTGGCTAGTAGGCTATGCTTTGGAAGAAATGGGGTTAGAAAAGGGCTGCGCGATCGCGATTGATATGCCCATGCATGTCGATGCTGTTGTAATATATTTAGCCATCGTATTGGCAGGTTATGTTGTGGTCTCAATCGCTGATTCATTCTCAGCACCCGAAATAAGCACCAGATTACGCCTTTCCAAGGCGAAAGCCATTTTCACTCAAGATCATATCATCAGAGGAAAAAAGAGAATACCATTATACAGCCGTGTTGTTGAAGCAAAATCTCCCATGGCAATCGTTATCCCTTGTTCAGGCTCTAACATTGGCGCAGAATTACGTGATGGAGACATTTCTTGGGACTACTTTCTTGAAAGGGCCAAGGAATTTAAAAATTGTGAATTTACCGCACGTGAGCAGCCAGTGGATGCATACACCAATATTCTATTTAGCTCCGGAACAACCGGTGAACCAAAAGCTATTCCCTGGACTCAGGCGACACCTTTAAAGGCTGCTGCCGACGGTTGGAGCCACCTTGACATTAGAAAAGGCGATGTAATAGTTTGGCCGACTAACTTGGGGTGGATGATGGGTCCTTGGTTAGTTTACGCAAGTCTTCTTAACGGAGCTAGTATCGCCCTATATAATGGGTCACCATTGGTTTCCGGCTTTGCTAAATTTGTGCAGGATGCTAAAGTTACTATGTTAGGTGTTGTCCCTAGTATTGTTAGATCATGGAAGTCGACTAATTGTGTGTCAGGATACGATTGGTCCACAATCCGCTGCTTTTCTTCGTCTGGAGAGGCTTCTAACGTTGATGAATATCTATGGCTGATGGGTAGAGCTAATTATAAACCAGTCATTGAAATGTGTGGTGGTACCGAAATAGGTGGAGCATTTAGTGCCGGCTCCTTCCTACAAGCTCAATCATTGAGCTCTTTCTCATCCCAGTGTATGGGTTGTACCCTATATATTTTGGACAAAAATGGTTACCCTATGCCGAAGAATAAGCCTGGAATCGGTGAACTGGCATTGGGTCCTGTAATGTTTGGTGCCAGTAAAACTCTGTTGAACGGTAACCATCATGATGTCTACTTTAAAGGTATGCCAACTCTGAATGGTGAAGTATTAAGAAGGCACGGTGACATTTTCGAACTTACATCGAATGGTTACTATCATGCTCATGGTAGGGCCGATGACACGATGAATATAGGTGGAATAAAAATTTCATCTATTGAGATTGAAAGAGTTTGCAACGAGGTTGATGATCGTGTCTTCGAGACTACTGCTATAGGCGTGCCTCCCTTAGGTGGGGGTCCAGAACAACTCGTGATTTTTTTTGTCTTGAAGGATAGCAATGATACAACGATAGATTTGAATCAATTGAGATTGAGTTTCAACCTCGGTCTGCAAAAAAAATTAAATCCATTGTTCAAAGTAACGAGGGTAGTCCCATTATCGTCACTACCGAGAACAGCTACAAATAAGATTATGAGGAGAGTTTTGAGGCAACAATTCTCTCACTTCGAGTGAG
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            tTEF1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            GATTATGAGGAGAGTTTTGAGGCAACAATTCTCTCACTTCGAGTGAGCTAAGGTTACCAAGGCTGCTCAAAAGGCTGCTAAGAAATAAGGAGATTGATAAGACTTTTCTAGTTGCATATCTTTTATATTTAAATCTTATCTATTAGTTAATTTTTTGTAATTTATCCTTATATATAGTCTGGTTATTCTAAAATATCATTTCAGTATCTAAAAATTCCCCTCTTTTTTCAGTTATATCTTAACAGGCGACAGTCCAAATGTTGATTTATCCCAGTCCGATTCATCAGGGTTGTGAAGCATTTTGTCAATGGTCGAAATCACATCAGTAATAGTGCCTCTTACTTGCCTCATAGAATTTCTTTCTCTTAACGTCACCGTTTGGTCTTTTATAGTTTCGAAATCTATGGTGATACCAAATGGTGTTCCCAATTCATCGTTACGGGCGTATTTTTTACCAATTGAAGTATTGGAATCGTCAATTTTAAAGTATATCTCTCTTTTACGTAAAGCCTGCGAGATCCTC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL7+<i>Cs</i>THCAS:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            CTTTAGTCGACAGCACTGACAGTCTCTCGGAAAGTGTCGTTGCGAGAGCCATGCATGTATGTTTCCATGGTTCGGGCGCATGTTTCTTACTTAAATATGATATGCAAGTAATCACACATTTGTCCGCCGGTGGAAAGAAGCAGGTCTTGTCGAACCCCGGGGATGCGACAGCAGAGGTTCGAACACGCAAAATCGTAATTTGATATTTATATGCGCGCCCACCTTCGCTGACAATTCCCGTTCATGAATCGTTTGTCAGTAATTGACGCGCCGGGGGTGCCTTGGGGGAGTGTTGTCAATTAACATACAAATATTCCCGTTCGTATCAATTTGCATATCCATCTCATCACATAGTAGTATTCCCGTTCGTATCCATTTGCATATCTCGTCACATAGTCTTCCCGTTCGTATCCATTTCATATCGTAACATCATACAGTCTTCACAATCTTCCCGTTCGTCCTCTCATCGTCAAGCCATTGATTGTCAATACACGCCTACATATTCCCGTTCTCTTGTCTGCCACATCGCTCGTGCGTTCTTCCCGTTTTTATGGGAAGACTGGGGTCATGTCGTCAATACAGCAGCAGACATAATGGGTGTTATATATGTCGAGTTTCACATCTGGCTGTACTAAGATATCCGTGACCCACTTTCACAACGATCACTTATCAGCGCTCAATCCCCTCTTGAGAAACACAATGTCCAACCCTAGGGAAAACTTCCTTAAATGTTTTTCGAAACATATTCCAAATAATGTTGCTAATCCTAAATTAGTGTACACTCAGCATGACCAACTTTACATGAGTATTTTGAACTCCACCATTCAAAACTTACGCTTCATTTCTGATACTACTCCTAAGCCATTGGTAATAGTAACGCCTTCAAATAATTCTCATATACAAGCGACCATTTTGTGCTCTAAGAAAGTTGGGTTGCAGATTAGAACAAGATCCGGAGGACACGATGCTGAGGGTATGTCATACATCTCACAAGTACCCTTCGTTGTCGTTGATTTAAGAAATATGCATAGTATCAAAATTGATGTCCATTCTCAAACTGCTTGGGTCGAAGCAGGTGCTACTTTAGGTGAGGTTTATTACTGGATCAATGAGAAGAACGAGAATTTATCCTTTCCCGGTGGGTATTGTCCTACAGTTGGAGTTGGTGGACATTTTTCGGGTGGTGGCTATGGCGCTTTAATGAGAAATTACGGTTTGGCAGCTGATAATATTATAGATGCCCATCTAGTTAATGTCGACGGCAAAGTTCTTGACCGTAAGTCAATGGGAGAAGATTTGTTTTGGGCCATTAGAGGCGGTGGTGGGGAAAACTTTGGAATTATTGCAGCGTGGAAAATCAAGT
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Cs</i>THCAS+tTPS1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            TAGTTGCCGTCCCTTCCAAATCTACTATTTTTTCTGTCAAGAAAAATATGGAGATACATGGACTGGTCAAACTCTTTAACAAGTGGCAGAACATAGCTTACAAATATGATAAAGACCTAGTGTTGATGACACACTTCATAACGAAAAATATCACCGATAACCACGGCAAGAATAAAACAACAGTTCACGGGTATTTTAGTTCTATTTTCCATGGTGGAGTTGATTCACTCGTTGATTTGATGAACAAATCTTTTCCAGAACTAGGTATTAAAAAAACTGACTGTAAGGAATTTTCCTGGATTGATACCACGATTTTCTACAGCGGTGTGGTGAACTTCAATACAGCTAACTTTAAAAAGGAAATCTTGCTAGATAGAAGCGCAGGCAAGAAGACGGCATTTTCAATTAAGCTTGATTATGTGAAAAAACCGATTCCAGAAACTGCTATGGTAAAAATCCTAGAGAAGTTATATGAAGAAGATGTTGGTGCCGGAATGTATGTCCTGTATCCGTACGGTGGTATCATGGAGGAAATAAGCGAATCGGCTATCCCATTCCCGCATAGGGCCGGTATCATGTATGAATTATGGTATACAGCGAGTTGGGAGAAGCAAGAAGATAACGAAAAACATATAAATTGGGTGAGAAGTGTATACAATTTCACTACCCCATATGTGAGCCAAAATCCAAGACTGGCCTATTTGAACTACCGTGACTTGGACCTTGGCAAAACTAACCACGCATCACCAAATAATTATACACAGGCACGGATATGGGGGGAAAAGTACTTTGGTAAAAATTTCAATCGACTGGTAAAGGTAAAGACCAAAGTAGACCCAAACAATTTTTTTAGGAATGAACAATCTATACCCCCTTTACCACCCCACCACCATTGATGAACCCGATGCAAATGAGACGATCGTCTATTCCTGGTCCGGTTTTCTCTGCCCTCTCTTCTATTCACTTTTTTTATACTTTATATAAAATTATATAAATGACATAACTGAAACGCCACACGTCCTCTCCTATTCGTTAACGCCTGTCTGTAGCGCTGTTACTGAAGCTGCGCAAGTAGTTTTTTCACCGTATAGGCCCTCTTTTTCTCTCTCTTTCTTTCTCTCCCGCGCTGATCTCTTCTTCGAAACAGATT
          </div>

          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For pCBDA plasmid:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Cs</i>TKS+pGAL1/10, pGAL1/10+<i>Cs</i>AAE1 and tTEF1 are
            identical to that for the pTHCA plasmid.
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            pGAL7+<i>Cs</i>CBDAS:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            CTTTAGTCGACAGCACTGACAGTCTCTCGGAAAGTGTCGTTGCGAGAGCCATGCATGTATGTTTCCATGGTTCGGGCGCATGTTTCTTACTTAAATATGATATGCAAGTAATCACACATTTGTCCGCCGGTGGAAAGAAGCAGGTCTTGTCGAACCCCGGGGATGCGACAGCAGAGGTTCGAACACGCAAAATCGTAATTTGATATTTATATGCGCGCCCACCTTCGCTGACAATTCCCGTTCATGAATCGTTTGTCAGTAATTGACGCGCCGGGGGTGCCTTGGGGGAGTGTTGTCAATTAACATACAAATATTCCCGTTCGTATCAATTTGCATATCCATCTCATCACATAGTAGTATTCCCGTTCGTATCCATTTGCATATCTCGTCACATAGTCTTCCCGTTCGTATCCATTTCATATCGTAACATCATACAGTCTTCACAATCTTCCCGTTCGTCCTCTCATCGTCAAGCCATTGATTGTCAATACACGCCTACATATTCCCGTTCTCTTGTCTGCCACATCGCTCGTGCGTTCTTCCCGTTTTTATGGGAAGACTGGGGTCATGTCGTCAATACAGCAGCAGACATAATGGGTGTTATATATGTCGAGTTTCACATCTGGCTGTACTAAGATATCCGTGACCCACTTTCACAACGATCACTTATCAGCGCTCAATCCCCTCTTGAGAAACACAATGTCCAACCCTCGTGAAAATTTCTTGAAATGTTTTAGTCAATATATTCCCAATAACGCGACAAATCTAAAATTGGTATATACTCAGAATAACCCATTATATATGTCAGTTTTGAACTCAACTATTCACAATTTGCGCTTCACCTCTGATACGACCCCCAAACCATTAGTTATCGTGACACCTAGCCATGTTTCTCATATTCAAGGTACAATCTTGTGTTCAAAAAAAGTCGGGCTTCAGATTAGGACCAGGTCTGGTGGGCACGACTCGGAAGGTATGAGTTACATCTCGCAAGTCCCCTTCGTTATAGTAGATCTACGTAATATGAGAAGCATTAAGATTGATGTACATAGCCAAACAGCCTGGGTTGAAGCTGGTGCTACGTTAGGAGAGGTTTATTACTGGGTCAATGAGAAGAATGAAAATTTGTCCTTAGCTGCCGGGTACTGTCCAACCGTTTGTGCAGGGGGTCATTTTGGTGGTGGAGGATATGGACCTTTAATGAGAAATTACGGTTTAGCAGCTGATAATATAATAGATGCTCACCTGGTAAATGTACATGGTAAAGTGCTTGACCGTAAGTCAATGGGCGAGGACCTATTCTGGGCTTTGCGAGGCGGTGGTGCAGAATCCTTCGGCATTATAGTCGCGTGGAAGATCAGATTGGTAGCAGTGCCGAAGTCC
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <i>Cs</i>CBDAS+tTPS1:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            ACAATGTTCAGTGTGAAAAAAATTATGGAGATACATGAATTAGTTAAGTTAGTTAACAAATGGCAAAATATTGCATATAAATACGATAAAGATCTTCTACTGATGACACATTTTATTACAAGAAATATAACTGACAATCAAGGGAAGAACAAAACCGCCATTCATACTTACTTTTCTTCTGTGTTTTTAGGTGGCGTTGACTCACTCGTCGATTTGATGAACAAATCCTTTCCAGAACTAGGAATTAAGAAGACTGATTGCAGGCAGCTGTCATGGATTGATACGATTATCTTTTACTCTGGAGTAGTCAACTATGATACTGATAACTTTAATAAGGAAATTCTTCTTGATAGAAGTGCCGGTCAAAATGGTGCATTTAAGATAAAATTAGATTACGTTAAAAAACCAATCCCGGAATCCGTGTTTGTTCAAATCCTAGAGAAACTGTATGAAGAAGACATCGGCGCTGGAATGTACGCTTTATACCCTTATGGTGGAATAATGGACGAAATTTCAGAGAGTGCAATTCCATTCCCGCACAGAGCCGGTATCCTTTACGAATTGTGGTACATATGCTCTTGGGAAAAACAGGAGGATAATGAAAAACATTTGAATTGGATTAGAAATATATATAATTTTATGACTCCATATGTCTCTAAAAATCCTAGATTGGCTTATCTGAACTATCGGGATCTCGATATTGGCATAAACGACCCAAAGAACCCTAACAACTATACTCAAGCGAGGATCTGGGGTGAAAAATATTTCGGCAAGAACTTCGATAGACTCGTTAAGGTTAAGACTTTGGTGGACCCAAATAACTTTTTTAGGAATGAACAATCGATCCCACCTTTACCCAGACATAGACACTGATGAACCCGATGCAAATGAGACGATCGTCTATTCCTGGTCCGGTTTTCTCTGCCCTCTCTTCTATTCACTTTTTTTATACTTTATATAAAATTATATAAATGACATAACTGAAACGCCACACGTCCTCTCCTATTCGTTAACGCCTGTCTGTAGCGCTGTTACTGAAGCTGCGCAAGTAGTTTTTTCACCGTATAGGCCCTCTTTTTCTCTCTCTTTCTTTCTCTCCCGCGCTGATCTCTTCTTCGAAACAGATT
          </div>
          <br />

          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Primers:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <table style={{ width: "100%" }}>
              <thead>
                <tr>
                  <th>gBlocks</th>
                  <th>Primer Type</th>
                  <th>5’ to 3’ Sequence</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><i>Pt</i>PinS+pGAL1/10</td>
                  <td>Forward</td>
                  <td>AAACCCTGGCGTTACCCCTGTCACAGCGTAACAGGATC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>TATAGCAATGAGCAGTTAAGCGTATTACTG</td>
                </tr>
                <tr>
                  <td>pGAL1/10+<i>Sl</i>NPPS+tTEF1</td>
                  <td>Forward</td>
                  <td>CTTAACTGCTCATTGCTATATTGAAGACGGATTAG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>ATGCCTCAGCACTAGTCCTGGAGGATCTCGCAGGCTTTAC</td>
                </tr>
                <tr>
                  <td>Linearized XII-4 Backbone for pPINE</td>
                  <td>Forward</td>
                  <td>CAGGACTAGTGCTGAGGCATTAATAG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>CAGGGGTAACGCCAGGGT</td>
                </tr>
                <tr>
                  <td><i>Aa</i>QHS1+pGAL1/10</td>
                  <td>Forward</td>
                  <td>GTTACCCCTGTCAAATGGGTATTGGGTGTACAAG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>AGGCACATCTGCGTTTCAGGAACGCGAC</td>
                </tr>
                <tr>
                  <td>pGAL1/10+<i>Sc</i>ERG20+tTEF1</td>
                  <td>Forward</td>
                  <td>CCTGAAACGCAGATGTGCCTCGCGCCGC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>ACTAGTCCTGGAGGATCTCGCAGGCTTTACGTAAAAGAG</td>
                </tr>
                <tr>
                  <td>Linearized XII-4 Backbone for pCARY</td>
                  <td>Forward</td>
                  <td>CGAGATCCTCCAGGACTAGTGCTGAGGCATTAATAG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>ACCCATTTGACAGGGGTAACGCCAGGGT</td>
                </tr>
                <tr>
                  <td><i>Cs</i>OAC+pGAL1/10</td>
                  <td>Forward</td>
                  <td>GTTACCCCTGTCACTTTCTAGGGGTATAATC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>GGGTTTAGAAGTGTATGATAGTTGGTTTGAAAC</td>
                </tr>
                <tr>
                  <td>pGAL1/10+<i>Cs</i>PT4+tTEF1</td>
                  <td>Forward</td>
                  <td>TATCATACACTTCTAAACCCTCACAACAAAAATC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>ATGCCTCAGCACTAGTCCTGGAGGATCTCGCAGGCTTTAC</td>
                </tr>
                <tr>
                  <td>Linearized XII-4 Backbone for pCBGA</td>
                  <td>Forward</td>
                  <td>CAGGACTAGTGCTGAGGCATTAATAG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>TAGAAAGTGACAGGGGTAACGCCAGGGT</td>
                </tr>
                <tr>
                  <td><i>Cs</i>TKS+pGAL1/10</td>
                  <td>Forward</td>
                  <td>TGGGAAAACCCTGGCGTTACCCCTGTCAGTATTTGATTGGAACC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>TTTTTTCTCCTTGACGTTAAAGTATAGAGGTATATTAAC</td>
                </tr>
                <tr>
                  <td>pGAL1/10+<i>Cs</i>AAE1</td>
                  <td>Forward</td>
                  <td>ATACTTTAACGTCAAGGAGAAAAAACCCCGG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>TTGGTAACCTTAGCTCACTCGAAGTGAGAGAATTG</td>
                </tr>
                <tr>
                  <td>tTEF1</td>
                  <td>Forward</td>
                  <td>ACTTCGAGTGAGCTAAGGTTACCAAGGCTGC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>TGTCGACTAAAGGAGGATCTCGCAGGCTTTAC</td>
                </tr>
                <tr>
                  <td>pGAL7+<i>Cs</i>THCAS</td>
                  <td>Forward</td>
                  <td>CTGCGAGATCCTCCTTTAGTCGACAGCACTG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>GGGACGGCAACTAACTTGATTTTCCACGCTG</td>
                </tr>
                <tr>
                  <td><i>Cs</i>THCAS+tTPS1</td>
                  <td>Forward</td>
                  <td>GGAAAATCAAGTTAGTTGCCGTCCCTTCCAAATC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>AATTAATGCCTCAGCACTAGTCCTGAATCTGTTTCGAAGAAGAGATCAGC</td>
                </tr>
                <tr>
                  <td>Linearized XI-3 Backbone for pTHCA</td>
                  <td>Forward</td>
                  <td>CAGGACTAGTGCTGAGGCATTAATTTAC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>CAGGGGTAACGCCAGGGT</td>
                </tr>
                <tr>
                  <td>pGAL7+<i>Cs</i>CBDAS</td>
                  <td>Forward</td>
                  <td>CTGCGAGATCCTCCTTTAGTCGACAGCACTGAC</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>CACTGAACATTGTGGACTTCGGCACTGCTAC</td>
                </tr>
                <tr>
                  <td><i>Cs</i>CBDAS+tTPS1</td>
                  <td>Forward</td>
                  <td>GTGCCGAAGTCCACAATGTTCAGTGTGAAAAAAATTATG</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>AATTAATGCCTCAGCACTAGTCCTGAATCTGTTTCGAAGAAGAG</td>
                </tr>
                <tr>
                  <td>Linearized XI-3 Backbone for pCBDA</td>
                  <td>Forward</td>
                  <td>CAGGGGTAACGCCAGGGT</td>
                </tr>
                <tr>
                  <td></td>
                  <td>Reverse</td>
                  <td>CAGGGGTAACGCCAGGGT</td>
                </tr>
              </tbody>
            </table>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Protocols
          </h2>
          <h3 style={{ fontSize: `${25 + fontSize}px`, color: "var(--logo)" }}>
            Media and Solutions
          </h3>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            YPD media:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>10g yeast extract</li>
              <li>20g peptone</li>
              <li>20g dextrose</li>
              <li>(for agar: 24g bacteriological agar)</li>
            </ul>
          </div>
          <br />

          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Dissolve in 1000mL Milli-Q water and autoclave.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            LB media:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>5g yeast extract</li>
              <li>10g tryptone</li>
              <li>10g NaCl</li>
              <li>(for agar: 24g bacteriological agar)</li>
            </ul>
          </div>
          <br />

          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Dissolve in 1000mL Milli-Q water and autoclave.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            10X TE buffer:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>100mM Tris base (12.11g in 1000mL of Milli-Q water)</li>
              <li>10mM EDTA (2.92g in 1000mL of Milli-Q water)</li>
            </ul>
          </div>
          <br />

          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Dissolve in 1000mL Milli-Q water and adjust pH to 8.0.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For a 1X solution, dilute 1:10.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            50X TAE buffer:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>242g Tris base</li>
              <li>57.1mL glacial acetic acid</li>
              <li>14.6122g EDTA</li>
            </ul>
          </div>
          <br />

          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Dissolve in 1000mL Milli-Q water and adjust pH to ~8.3.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            For a 1X solution, dilute 1:50.
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            1M lithium acetate (LiAc):
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>3.30g lithium acetate</li>
            </ul>
          </div>
          <br />

          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Dissolve in 50mL Milli-Q water, filter sterilize, and store at 4˚C.
          </div>
          <br />
        </ReadAloud>

        <ReadAloud>
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            PCR
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Materials:
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ul>
              <li>Thermocycler</li>
              <li>Q5 2X Master Mix (stored at -20°C)</li>
              <li>Q5 high-fidelity polymerase (stored at -20˚C)</li>
              <li>10µM primers (stored at -20˚C)</li>
              <li>1ng/µL template DNA (stored at -20˚C)</li>
              <li>Sterile Milli-Q water</li>
            </ul>
          </div>

          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <ol>
              <li>
                To sterile PCR tubes on ice, add the following:
                <ul>
                  <li>8 µL Milli-Q water</li>
                  <li>1 µL of 10µM forward primer</li>
                  <li>1 µL of 10µM reverse primer</li>
                  <li>
                    <p>10 µL of Q5 Master Mix</p>
                    <p>This makes up a 20µL PCR reaction volume.</p>
                    <p>
                      Also include a negative control tube where the volume of
                      DNA will be replaced with Milli-Q water.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  To each tube (except the negative control), add 1 µL of 1ng/µL
                  template DNA.
                </p>
              </li>
              <li>
                Place the PCR tubes into a thermocycler and set the following
                PCR cycle settings:
                <table style={{ width: "80%" }}>
                  <thead>
                    <tr>
                      <th>Step</th>
                      <th>Temperature (°C)</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Initial denaturation</td>
                      <td>98</td>
                      <td>30 sec</td>
                    </tr>
                    <tr>
                      <td>Denaturation</td>
                      <td>98</td>
                      <td>5-10 sec</td>
                    </tr>
                    <tr>
                      <td>Annealing</td>
                      <td>
                        Dependent on primers (ideally ~5˚C below Tm of primers);
                        within 45-72
                      </td>
                      <td>10-30 sec</td>
                    </tr>
                    <tr>
                      <td>Extension</td>
                      <td>72</td>
                      <td>20-30 sec/kb</td>
                    </tr>
                    <tr>
                      <td>Final extension</td>
                      <td>72</td>
                      <td>5-10 min</td>
                    </tr>
                    <tr>
                      <td>Hold</td>
                      <td>4</td>
                      <td>Infinity</td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  35 cycles of denaturation, annealing, and extension should be
                  run.
                </div>
              </li>
              <li>
                Continue to agarose gel electrophoresis and/or PCR cleanup, or
                store amplified DNA at -20˚C.
              </li>
            </ol>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            High-GC PCR
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>Materials:</p>
            <ul>
              <li>Thermocycler</li>
              <li>PHusion Hot-Start II Polymerase (stored at -20°C)</li>
              <li>5x GC Buffer (contains 7.5 mM MgCl2)</li>
              <li>DMSO</li>
              <li>2 mM dNTPs</li>
              <li>10µM primers (stored at -20˚C)</li>
              <li>1ng/µL template DNA (stored at -20˚C)</li>
              <li>
                <p>Sterile Milli-Q water</p>
              </li>
            </ul>

            <ol>
              <li>
                <p>To sterile PCR tubes on ice, add the following:</p>
                <ul>
                  <li>6.2 µL Milli-Q water</li>
                  <li>1 µL of 10µM forward primer</li>
                  <li>1 µL of 10µM reverse primer</li>
                  <li>4 µL of 5x GC buffer</li>
                  <li>2 µL of 2 mM dNTPs</li>
                  <li>0.6 µL DMSO</li>
                  <li>
                    <p>0.2 µL PHusion polymerase</p>
                    <p>This makes up a 20µL PCR reaction volume.</p>
                    <p>
                      Also include a negative control tube where the volume of
                      DNA will be replaced with Milli-Q water.
                    </p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  To each tube (except the negative control), add 5 µL of 1ng/µL
                  template DNA.
                </p>
              </li>
              <li>
                Place the PCR tubes into a thermocycler and set the following
                PCR cycle settings:
                <table>
                  <thead>
                    <tr>
                      <th>Step</th>
                      <th>Temperature (°C)</th>
                      <th>Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Initial denaturation</td>
                      <td>98</td>
                      <td>30 sec</td>
                    </tr>
                    <tr>
                      <td>Denaturation</td>
                      <td>98</td>
                      <td>5-10 sec</td>
                    </tr>
                    <tr>
                      <td>Annealing</td>
                      <td>
                        Dependent on primers (ideally ~5˚C below Tm of primers);
                        within 45-72
                      </td>
                      <td>10-30 sec</td>
                    </tr>
                    <tr>
                      <td>Extension</td>
                      <td>72</td>
                      <td>20-30 sec/kb</td>
                    </tr>
                    <tr>
                      <td>Final extension</td>
                      <td>72</td>
                      <td>5-10 min</td>
                    </tr>
                    <tr>
                      <td>Hold</td>
                      <td>4</td>
                      <td>Infinity</td>
                    </tr>
                  </tbody>
                </table>
              </li>
              <br />
              <div>
                35 cycles of denaturation, annealing, and extension should be
                run.
              </div>
              <br />
              <li>
                Continue to agarose gel electrophoresis and/or PCR cleanup, or
                store amplified DNA at -20˚C.
              </li>
            </ol>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Agarose Gel Electrophoresis
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>Materials:</p>
            <ul>
              <li>1X TAE buffer</li>
              <li>Agarose</li>
              <li>DNA visualization dye (GelRed or GelGreen)</li>
              <li>DNA samples</li>
              <li>6X DNA loading dye</li>
              <li>Agarose gel electrophoresis apparatus</li>
              <li>
                <p>Electrophoresis power pack</p>
              </li>
              <li>
                <p>
                  For a 0.8% gel, add 50mL of 1X TAE to 0.4g of agarose. Swirl
                  and microwave for 30 sec, then repeat in 15 sec increments
                  until agarose is dissolved.
                </p>
              </li>
              <li>
                Once agarose solution is no longer steaming and is cool enough
                to hold for a few seconds without burning, add 5µL of 10000x DNA
                visualization dye, swirl to mix, then pour into gel casting
                apparatus and add comb.
              </li>
              <li>
                Once gel has set, turn gel mold tray sideways and add enough 1X
                TAE to cover electrodes.
              </li>
              <li>
                Prepare DNA samples by adding 2µL of 6X DNA loading dye and 8µL
                of MilliQ water to 2µL of DNA sample.{" "}
              </li>
              <li>
                Load 2µL of ladder + 10µL of MilliQ and DNA+dye samples from
                Step 4.
              </li>
              <li>
                Run gel at 120V until dye front reaches approximately 3/4 of the
                way to the end of the gel.
              </li>
            </ul>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Bacterial Transformation
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>Materials: </p>
            <ul>
              <li>Competent cells (from -80˚C)</li>
              <li>Plasmid DNA (1ng/µL)</li>
              <li>42˚C water bath/heat block</li>
              <li>SOC media (preferred), or LB media</li>
              <li>Selective media plates</li>
              <li>Ice</li>
              <li>37˚C stationary incubator</li>
            </ul>
            <p>
              Handle competent cells very carefully, as cell membranes are very
              fragile. Never mix by pipetting.
            </p>
            <ol>
              <li>Thaw competent cells on ice.</li>
              <li>
                Add 1µL of 1ng/µL plasmid to competent cells; very gently flick
                to mix.
              </li>
              <li>Incubate on ice for 30 min.</li>
              <li>Heat shock at 42˚C for 30 sec.</li>
              <li>Immediately incubate on ice for 2 min.</li>
              <li>
                Add 1000µL of SOC or LB media and incubate in orbital shaker for
                1h.
              </li>
              <li>
                Plate 100µL of transformation mixture onto selective plate(s);
                incubate plates overnight at 37˚C.
              </li>
            </ol>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            PCR Cleanup
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>
              Plasmid miniprep was performed as per NEB’s protocol for their
              Exo-CIP Rapid PCR Cleanup Kit:{" "}
              <a href="https://www.neb.ca/neb/protocols.php?p=protocols/2019/01/16/protocol-for-exo-ciprapid-pcr-cleanup-e1050">
                https://international.neb.com/protocols/2015/11/20/monarch-plasmid-dna-miniprep-kit-protocol-t1010
              </a>
            </p>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Gel Extraction
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>
              After cutting the gel stained with GelGreen, gel extraction was
              performed as per QIAGEN’s protocol for their QIAquick Gel
              Extraction Kit:{" "}
              <a href="https://www.qiagen.com/us/resources/resourcedetail?id=a72e2c07-7816-436f-b920-98a0ede5159a&amp;lang=en">
                https://www.qiagen.com/us/resources/resourcedetail?id=a72e2c07-7816-436f-b920-98a0ede5159a&amp;lang=en
              </a>
            </p>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Plasmid Miniprep
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>
              Plasmid miniprep was performed as per NEB’s protocol for their
              Monarch Plasmid DNA Miniprep Kit:{" "}
              <a href="https://international.neb.com/protocols/2015/11/20/monarch-plasmid-dna-miniprep-kit-protocol-t1010">
                https://international.neb.com/protocols/2015/11/20/monarch-plasmid-dna-miniprep-kit-protocol-t1010
              </a>
            </p>
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Gibson Assembly
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Gibson assembly was performed as per NEB’s protocol for their Gibson
            Assembly Kit:
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>
              <a href="https://international.neb.com/protocols/2012/12/11/gibson-assembly-protocol-e5510">
                https://international.neb.com/protocols/2012/12/11/gibson-assembly-protocol-e5510
              </a>
            </p>
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Note that incubation time at 50˚C was 60 minutes for mixtures of 2-3
            fragments, and 80 minutes for mixtures of 4-6 fragments.
          </div>
        </ReadAloud>

        <ReadAloud>
          <br />
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            Yeast Transformation
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>Materials: </p>
            <ul>
              <li>Log-phase yeast culture</li>
              <li>Plasmid DNA to be transformed</li>
              <li>
                10µg/µL salmon sperm DNA (boiled at 100˚C for 10 min, then iced
                until cool)
              </li>
              <li>PEG4000</li>
              <li>1M LiAc</li>
              <li>10X TE</li>
              <li>DMSO</li>
              <li>Sterile Milli-Q water</li>
              <li>Selective media plates</li>
              <li>30˚C water bath/heat block</li>
              <li>42˚C water bath/heat block</li>
              <li>Ice</li>
              <li>30˚C stationary incubator</li>
            </ul>
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>Solutions:</p>
            <ul>
              <li>
                <p>100mM Lithium Acetate/0.5X TE (prepare fresh every time)</p>
                <p>
                  {" "}
                  (For a 5mL solution. Considering that 2mL is needed for each
                  culture to be transformed, adjust accordingly.)
                </p>
                <ul>
                  <li>2 ml sterile Milli-Q water</li>
                  <li>2.5 ml 1x TE</li>
                  <li>
                    <p>0.5 ml 1M LiAc</p>
                    <p>Filter sterilize.</p>
                  </li>
                </ul>
              </li>
              <li>
                <p>
                  100mM Lithium Acetate/40% PEG4000/1X TE (prepare fresh every
                  time)
                </p>
                <p>
                  {" "}
                  (For a 5mL solution. Considering that 300µL is needed for each
                  1.5mL tube from Step 4, adjust accordingly.)
                </p>
                <ul>
                  <li>2.25 mL sterile Milli-Q water</li>
                  <li>0.5 mL 10X TE</li>
                  <li>0.5 mL 1M LiAc</li>
                  <li>
                    <p>2 g PEG4000</p>
                    <p>Filter sterilize.</p>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>Perform all steps using proper aseptic technique.</p>
            <ol>
              <li>
                Grow yeast to log phase (1-2 x 10^6 cells/mL, corresponding to
                OD600 = ~0.36).
              </li>
              <li>
                Centrifuge entire culture for 5min at 4000 rpm. Completely
                resuspend pellet in 10mL sterile 1X TE by pulse vortexing on low
                speed.
              </li>
              <li>
                Centrifuge entire culture for 5min at 4000 rpm. Completely
                resuspend pellet in 2mL of 100mM lithium acetate (LiAc)/0.5X TE.
                Incubate 10 min at room temperature. From here onwards, handle
                cells carefully, as cell membranes are fragile.
              </li>
              <li>
                Into a sterile 1.5 mL tube, add:
                <ul>
                  <li>0.4-1µg DNA (use 1µg for integrative plasmids)</li>
                  <li>
                    100µg (10µl) of 10µg/µL salmon sperm DNA (boiled at 100˚C
                    for 10min, then iced until cool)
                  </li>
                  <li>100µL of LiAc/TE-incubated yeast (from step 3)</li>
                  <li>
                    Also set up a negative (no plasmid) control containing no
                    plasmid DNA for each unique yeast strain to be transformed.
                  </li>
                </ul>
              </li>
              <li>
                Add 300µL of 100mM LiAc/40% PEG4000/1X TE. Mix by gently
                pipetting.
              </li>
              <li>Incubate at 30˚C for 30 min.</li>
              <li>Add 40µL DMSO. Mix by gently pipetting.</li>
              <li>Heat shock at 42˚C for 7 min.</li>
              <li>
                Ice immediately for 2 min, then plate on selective media.
                Incubate plate(s) at 30˚C.
              </li>
            </ol>
          </div>
        </ReadAloud>
        <br />
        <ReadAloud>
          <h2 style={{ fontSize: `${30 + fontSize}px`, color: "var(--logo)" }}>
            References
          </h2>
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Brachmann, C. B., Davies, A., Cost, G. J., Caputo, E., Li, J.,
            Hieter, P., & Boeke, J. D. (1998). Designer deletion strains derived
            from <i>S. cerevisiae</i> S288C: A useful set of strains
            and plasmids for PCR-mediated gene disruption and other
            applications. <i>Yeast (Chichester, England)</i>, <i>14</i>(2),
            115-132.{" "}
            <a href="https://doi.org/10.1002/(SICI)1097-0061(19980130)14:2<115::AID-YEA204>3.0.CO;2-2">
              https://doi.org/10.1002/(SICI)1097-0061(19980130)14:2&lt;115::AID-YEA204&gt;3.0.CO;2-2
            </a>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            <p>
              Jessop-Fabre, M. M., Jakociunas, T., Stovicek, V., Dai, Z.,
              Jensen, M. K., Keasling, J. D., &amp; Borodina, I. (2016).
              EasyClone-MarkerFree: A vector toolkit for marker-less integration
              of genes into <i>S. cerevisiae</i> via CRISPR-Cas9.{" "}
              <em>Biotechnology journal</em>, <em>11</em>(8), 1110-1117.{" "}
              <a href="https://doi.org/10.1002/biot.201600147">
                https://doi.org/10.1002/biot.201600147
              </a>
            </p>
          </div>
          <br />
          <div
            className="page-text"
            style={{ fontSize: `${18 + fontSize}px`, marginBottom: "2vh" }}
          >
            Song, Y., Lee, B., Cho, S., Cho, Y., Kim, S., Kang, T. J., Kim, S.
            C., & Cho, B. K. (2015). Determination of single nucleotide variants
            in <i>E. coli</i> DH5α by using short-read sequencing.{" "}
            <i>FEMS microbiology letters</i>, <i>362</i>(11), fnv073.{" "}
            <a href="https://doi.org/10.1093/femsle/fnv073">
              https://doi.org/10.1093/femsle/fnv073
            </a>
          </div>
        </ReadAloud>
      </div>
    ),
  };

  return (
    <div className="page">
      <h1 className="page-title">Proof of Concept</h1>
      <ButtonSection sections={sections} />
    </div>
  );
};

export default ProofOfConcept;
